
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

!function(e,n,a){function o(e,n){return typeof e===n}function s(){var e,n,a,s,t,c,r;for(var u in l)if(l.hasOwnProperty(u)){if(e=[],n=l[u],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(a=0;a<n.options.aliases.length;a++)e.push(n.options.aliases[a].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,t=0;t<e.length;t++)c=e[t],r=c.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),i.push((s?"":"no-")+r.join("-"))}}function t(e){var n=u.className,a=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+a+"no-js(\\s|$)");n=n.replace(o,"$1"+a+"js$2")}Modernizr._config.enableClasses&&(n+=" "+a+e.join(" "+a),p?u.className.baseVal=n:u.className=n)}function c(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}var i=[],l=[],r={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var a=this;setTimeout(function(){n(a[e])},0)},addTest:function(e,n,a){l.push({name:e,fn:n,options:a})},addAsyncTest:function(e){l.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=r,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase();Modernizr.addTest("audio",function(){var e=c("audio"),n=!1;try{n=!!e.canPlayType,n&&(n=new Boolean(n),n.ogg=e.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/,""),n.mp3=e.canPlayType('audio/mpeg; codecs="mp3"').replace(/^no$/,""),n.opus=e.canPlayType('audio/ogg; codecs="opus"')||e.canPlayType('audio/webm; codecs="opus"').replace(/^no$/,""),n.wav=e.canPlayType('audio/wav; codecs="1"').replace(/^no$/,""),n.m4a=(e.canPlayType("audio/x-m4a;")||e.canPlayType("audio/aac;")).replace(/^no$/,""))}catch(a){}return n}),s(),t(i),delete r.addTest,delete r.addAsyncTest;for(var f=0;f<Modernizr._q.length;f++)Modernizr._q[f]();e.Modernizr=Modernizr}(window,document);
var lhcError = {
log : function(message, filename, lineNumber, stack, column) {
var e;
e = {};
e.message = message || "";
e.location = location && location.href ? location.href : "";
e.message += "\n" + window.navigator.userAgent;
e.file = filename || "";
e.line = lineNumber || "";
e.column = column || "";
e.stack = stack ? JSON.stringify(stack) : "";
e.stack = e.stack.replace(/(\r\n|\n|\r)/gm, "");
var xhr = new XMLHttpRequest();
xhr.open( "POST", WWW_DIR_JAVASCRIPT + '/audit/logjserror', true);
xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
xhr.send( "data=" + encodeURIComponent( JSON.stringify(e) ) );
}
}
window.addEventListener('error', function(e) {
if (lhcError && (e.filename.indexOf('js_static') !== -1 || e.filename.indexOf('compiledtemplates') !== -1 || e.filename.indexOf('defaulttheme') !== -1)) {
lhcError.log(e.message, e.filename, e.lineNumber || e.lineno, e.error.stack, e.colno);
}
})
try {
function csrfSafeMethod(method) {
return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
};
$.ajaxSetup({
crossDomain: false, // obviates need for sameOrigin test
cache: false,
beforeSend: function(xhr, settings) {
if (!csrfSafeMethod(settings.type)) {
xhr.setRequestHeader("X-CSRFToken", confLH.csrf_token);
}
}
});
$.postJSON = function(url, data, callback) {
return $.post(url, data, callback, "json");
};
var LHCCallbacks = {};
function lh(){
this.wwwDir = WWW_DIR_JAVASCRIPT;
this.addmsgurl = "chat/addmsgadmin/";
this.syncadmin = "chat/syncadmin";
this.closechatadmin = "chat/closechatadmin/";
this.deletechatadmin = "chat/deletechatadmin/";
this.syncadmininterfaceurl = "chat/syncadmininterface/";
this.accepttransfer = "chat/accepttransfer/";
this.trasnsferuser = "chat/transferuser/";
this.channel = null;
this.ignoreAdminSync = false;
this.disableremember = false;
this.operatorTyping = false;
this.forceBottomScroll = false;
this.appendSyncArgument = '';
this.nodeJsMode = false;
this.previous_chat_id = 0;
this.gmaps_loaded = false;
this.disableSync = false;
this.chat_id = null;
this.hash = null;
this.soundIsPlaying = false;
this.soundPlayedTimes = 0;
this.last_message_id = 0;
this.isSinchronizing = false;
this.isWidgetMode = false;
this.isEmbedMode = false;
this.syncroRequestSend = false;
this.currentMessageText = '';
this.setSynchronizationRequestSend = function(status)
{
this.syncroRequestSend = status;
};
this.chatsSynchronising = [];
this.chatsSynchronisingMsg = [];
this.notificationsArray = [];
this.notificationsArrayMail = [];
this.speechHandler = false;
this.underMessageAdd = false;
this.closeWindowOnChatCloseDelete = false;
this.userTimeout = false;
this.lastOnlineSyncTimeout = false;
this.setwwwDir = function (wwwdir){
this.wwwDir = wwwdir;
};
this.setDisableRemember = function (value)
{
this.disableremember = value;
};
this.setSynchronizationStatus = function(status)
{
this.underMessageAdd = status;
};
this.startCoBrowse = function(chat_id)
{
popupWindow = window.open(this.wwwDir + 'cobrowse/browse/'+chat_id,'chatwindow-cobrowse-chat-id-'+chat_id,"menubar=1,resizable=1,width=800,height=650");
if (popupWindow !== null) {
popupWindow.focus();
}
return false;
};
this.tabIconContent = 'face';
this.tabIconClass = 'icon-user-status material-icons icon-user-online';
this.audio = typeof window.Audio !== "undefined" ? new Audio() : null;
if (this.audio !== null) {
this.audio.autoplay = 'autoplay';
}
this.reloadTab = function(chat_id, tabs, nick, internal)
{
$('#ntab-chat-'+chat_id).text(nick);
if ($('#CSChatMessage-'+chat_id).length != 0){
$('#CSChatMessage-'+chat_id).unbind('keydown', function(){});
$('#CSChatMessage-'+chat_id).unbind('keyup', function(){});
}
this.removeSynchroChat(chat_id, true);
this.removeBackgroundChat(chat_id);
this.hideNotification(chat_id);
var inst = this;
$.get(this.wwwDir +'chat/adminchat/'+chat_id+'/(remember)/true', function(data) {
$('#chat-id-'+chat_id).html(data);
inst.setFocus(chat_id);
inst.rememberTab(chat_id);
inst.addQuateHandler(chat_id);
inst.loadMainData(chat_id);
ee.emitEvent('chatTabLoaded', [chat_id]);
ee.emitEvent('chatStartTab', [chat_id, {name: nick, focus: true}]);
!internal && inst.channel && inst.channel.postMessage({'action':'reload_chat','args':{'nick': nick, 'chat_id' : parseInt(chat_id)}});
});
}
this.loadMainData = function(chat_id) {
var _that = this;
$.getJSON(this.wwwDir + 'chat/loadmaindata/' + chat_id, { }, function(data) {
$.each(data.items, function( index, dataElement ) {
var el = $(dataElement.selector);
if (typeof dataElement.attr !== 'undefined') {
$.each(dataElement.attr, function( attr, data ) {
if (attr == 'text') {
el.text(data);
} else {
el.attr(attr,data);
}
});
}
if (typeof dataElement.action !== 'undefined') {
if (dataElement.action == 'hide') {
el.hide();
} else if (dataElement.action == 'remove_class') {
el.removeClass(dataElement.class);
} else if (dataElement.action == 'add_class') {
el.addClass(dataElement.class);
} else if (dataElement.action == 'keyupmodal') {
el.bind('keyup', dataElement.event_data.a + '+' + dataElement.event_data.b, function() {
lhc.revealModal({'url':WWW_DIR_JAVASCRIPT+dataElement.event_data.url});
});
} else if (dataElement.action == 'keyup') {
el.bind('keyup', dataElement.event_data.a + '+' + dataElement.event_data.b, function() {
var pdata = {
msg	: '!'+dataElement.event_data.cmd
};
$.postJSON(_that.wwwDir + _that.addmsgurl + chat_id, pdata , function(data) {
if (LHCCallbacks.addmsgadmin) {
LHCCallbacks.addmsgadmin(chat_id);
};
ee.emitEvent('chatAddMsgAdmin', [chat_id]);
if (data.r != '') {
$('#messagesBlock-'+chat_id).append(data.r).scrollTop($("#messagesBlock-"+chat_id).prop("scrollHeight")).find('.pending-storage').remove();
};
if (data.hold_removed === true) {
$('#hold-action-'+chat_id).removeClass('btn-outline-info');
} else if (data.hold_added === true) {
$('#hold-action-'+chat_id).addClass('btn-outline-info');
}
if (data.update_status === true) {
_that.updateVoteStatus(chat_id);
}
_that.syncadmincall();
return true;
});
});
} else if(dataElement.action == 'show') {
el.show();
} else if(dataElement.action == 'remove') {
el.remove();
} else if(dataElement.action == 'event') {
ee.emitEvent(dataElement.event_name, dataElement.event_value);
} else if(dataElement.action == 'click') {
if (confLH.no_scroll_bottom !== 1){
el.attr('auto-scroll',1);
}
el.click();
}
}
});
ee.emitEvent('mainChatDataLoaded', [chat_id, data]);
}).fail(function() {
});
}
this.getSelectedText = function () {
var text = '';
var selection;
if (window.getSelection) {
selection = window.getSelection();
text = selection.toString();
} else if (document.selection && document.selection.type !== 'Control') {
selection = document.selection.createRange();
text = selection.text;
}
return {
selection: selection,
text: text
};
}
this.popoverShown = false;
this.popoverShownNow = false
this.selection = null;
this.mouseContextMenu = function(e) {
if (e.which == 3 && typeof $(this).attr('id') !== 'undefined') {
$('.popover-copy').popover('dispose');
var selected = e.data.that.getSelectedText();
var hasSelection = false;
if (selected.text.length && (e.data.that.selection === null || e.data.that.selection.text !== selected.text)) {
hasSelection = true;
e.data.that.selection = selected;
}
var msgId = $(this).attr('id').replace('msg-','');
var canEdit = !$('#CSChatMessage-'+e.data.chat_id).attr('readonly');
var isOwner = ($('#CSChatMessage-'+e.data.chat_id).attr('disable-edit') !== "true" && (
($(this).attr('data-op-id') == confLH.user_id && ($('#CSChatMessage-'+e.data.chat_id).attr('edit-all') === "true") || ($('#messagesBlock-' + e.data.chat_id + ' > div.message-admin').length > 0 && msgId == $('#messagesBlock-' + e.data.chat_id + ' > div.message-admin').last().attr('id').replace('msg-',''))) ||
($('#CSChatMessage-'+e.data.chat_id).attr('edit-op') === "true" && (parseInt($(this).attr('data-op-id')) > 0 || parseInt($(this).attr('data-op-id')) === -2)) ||
($('#CSChatMessage-'+e.data.chat_id).attr('edit-vis') === "true" && parseInt($(this).attr('data-op-id')) === 0)
)
) && canEdit;
var chatId = parseInt($(this).attr('data-chat-id') ?? e.data.chat_id);
var canRemove = (parseInt($(this).attr('data-op-id')) === 0 && $('#CSChatMessage-'+e.data.chat_id).attr('remove-msg-vi') === "true") || ((parseInt($(this).attr('data-op-id')) === -2 || parseInt($(this).attr('data-op-id')) > 0) && $('#CSChatMessage-'+e.data.chat_id).attr('remove-msg-op') === "true");
var quoteParams = {
placement:'right',
trigger:'manual',
animation:false,
html:true,
container:'#chat-id-'+e.data.chat_id,
template : '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>',
content:function(){
return (canEdit ? ('<a href="#" id="copy-popover-'+e.data.chat_id+'" ><i class="material-icons">&#xE244;</i>'+confLH.transLation.quote+'</a><br/>') : '') + (canRemove ? '<a href="#" id="remove-popover-'+e.data.chat_id+'" ><i class="material-icons">delete</i>'+confLH.transLation.remove+'</a><br/>' : '') + (chatId == e.data.chat_id && isOwner ? '<a href="#" id="edit-popover-'+e.data.chat_id+'" ><i class="material-icons">edit</i>'+confLH.transLation.edit+'</a><br/>' : '') + '<a href="#" id="ask-help-popover-'+e.data.chat_id+'" ><i class="material-icons">supervisor_account</i>'+confLH.transLation.ask_help+'</a>' + (hasSelection ? '<br/><a href="#" id="copy-text-popover-'+e.data.chat_id+'" ><i class="material-icons">content_copy</i>'+confLH.transLation.copy+' (Ctrl+C)</a>' : '') + (!hasSelection ? '<br/><a href="#" id="copy-all-text-popover-'+e.data.chat_id+'" ><i class="material-icons">content_copy</i>'+confLH.transLation.copy+' (Ctrl+C)</a><br/><a href="#" id="copy-group-text-popover-'+e.data.chat_id+'" ><i class="material-icons">content_copy</i>'+confLH.transLation.copy_group+'</a>' : '')+(chatId == e.data.chat_id && !hasSelection ? '<br/><a href="#" id="translate-msg-'+e.data.chat_id+'" ><i class="material-icons">language</i>'+confLH.transLation.translate+'</a>' : '');
}
}
var containerPopover = $('#messagesBlock-'+e.data.chat_id+' > #msg-'+msgId+' > .msg-body');
if (containerPopover.length == 0) return ;
ee.emitEvent('quoteActionRight', [quoteParams, e.data.chat_id, msgId]);
containerPopover.popover(quoteParams).popover('show').addClass('popover-copy');
$('#copy-popover-'+e.data.chat_id).click(function(event){
event.stopPropagation();
event.preventDefault();
$.getJSON(e.data.that.wwwDir + 'chat/quotemessage/' + msgId, function(data){
data.msg && e.data.that.insertTextToMessageArea(e.data.chat_id, data.msg, msgId);
e.data.that.hidePopover();
});
});
$('#remove-popover-'+e.data.chat_id).click(function(event){
event.stopPropagation();
event.preventDefault();
$.postJSON(e.data.that.wwwDir + 'chat/deletemsg/' + chatId + '/' + msgId, function(data){
if (data.error == 'f') {
e.data.that.hidePopover();
$('#msg-'+msgId).remove();
} else {
alert(data.result);
}
});
});
$('#ask-help-popover-'+e.data.chat_id).click(function(event){
event.stopPropagation();
event.preventDefault();
$.getJSON(e.data.that.wwwDir + 'chat/quotemessage/' + msgId, function(data){
if (!$('#private-chat-tab-link-'+e.data.chat_id).attr('private-loaded')) {
$('#private-chat-tab-link-'+e.data.chat_id).attr('private-loaded',true).click();
(new bootstrap.Tab(document.querySelector('#private-chat-tab-link-'+e.data.chat_id))).show();
ee.emitEvent('privateChatStart', [e.data.chat_id,{'default_message':data.msg}]);
} else {
$('#private-chat-tab-link-'+e.data.chat_id).attr('private-loaded',true).click();
(new bootstrap.Tab(document.querySelector('#private-chat-tab-link-'+e.data.chat_id))).show();
ee.emitEvent('groupChatPrefillMessage', [e.data.chat_id,data.msg]);
}
e.data.that.hidePopover();
});
});
!hasSelection && $('#translate-msg-'+e.data.chat_id).click(function(event){
event.stopPropagation();
event.preventDefault();
lhc.methodCall('lhc.translation','translateMessageVisitor',{'msg_id':msgId,'chat_id':e.data.chat_id});
e.data.that.hidePopover();
});
!hasSelection && $('#copy-all-text-popover-'+e.data.chat_id).click(function(event){
event.stopPropagation();
event.preventDefault();
$.getJSON(e.data.that.wwwDir + 'chat/quotemessage/' + msgId, function(data){
lhinst.copyContentRaw(data.msg);
e.data.that.hidePopover();
});
});
!hasSelection && $('#copy-group-text-popover-'+e.data.chat_id).click(function(event){
event.stopPropagation();
event.preventDefault();
$.getJSON(e.data.that.wwwDir + 'chat/quotemessage/' + msgId +'/(type)/group', function(data){
lhinst.copyContentRaw(data.msg);
e.data.that.hidePopover();
});
});
isOwner && $('#edit-popover-'+e.data.chat_id).click(function(event){
event.stopPropagation();
event.preventDefault();
$.getJSON(e.data.that.wwwDir + 'chat/editprevious/' + e.data.chat_id + '/' + msgId, function(data){
if (data.error == 'f') {
var textArea = $('#CSChatMessage-'+e.data.chat_id);
if (textArea.prop('nodeName') == 'LHC-EDITOR') {
textArea[0].setContent(data.msg,{"convert_bbcode" : true});
textArea.attr('data-msgid',data.id).addClass('edit-mode');
textArea[0].setFocus();
} else {
textArea.val(data.msg).attr('data-msgid',data.id).addClass('edit-mode');
textArea.focus();
}
$('#msg-'+data.id).addClass('edit-mode');
} else {
alert(data.result);
}
});
e.data.that.hidePopover();
});
hasSelection && $('#copy-text-popover-'+e.data.chat_id).click(function(event){
event.stopPropagation();
event.preventDefault();
lhinst.copyContentRaw(e.data.that.getSelectedTextPlain());
e.data.that.hidePopover();
});
e.data.that.popoverShown = true;
e.data.that.popoverShownNow = false;
return false;
}
}
this.copyContentRaw = function(content){
var textArea = document.createElement("textarea");
textArea.value = content;
textArea.style.top = "0";
textArea.style.left = "0";
textArea.style.position = "fixed";
document.body.appendChild(textArea);
textArea.focus();
textArea.select();
try {
var successful = document.execCommand('copy');
} catch (err) {
alert('Oops, unable to copy');
}
document.body.removeChild(textArea);
}
this.insertTextToMessageArea = function (chat_id, msg, msgId) {
var textArea = $('#CSChatMessage-'+chat_id);
if (textArea.prop('nodeName') == 'LHC-EDITOR') {
textArea[0].insertContent('[quote'+ (msgId ? '=' + msgId : '') + ']'+msg+'[/quote]',{"new_line":true,"convert_bbcode" : true});
} else {
var textAreaVal = textArea.val().replace(/^\s*\n/g, "");
textArea.val((textAreaVal != '' ? textAreaVal + '[quote'+ (msgId ? '=' + msgId : '') + ']' + msg + '[/quote]' : '[quote'+ (msgId ? '=' + msgId : '') + ']'+msg+'[/quote]')+"\n").focus();
var ta = textArea[0];
var maxrows = 30;
var lh = ta.clientHeight / ta.rows;
while (ta.scrollHeight > ta.clientHeight && !window.opera && ta.rows < maxrows) {
ta.style.overflow = 'hidden';
ta.rows += 1;
}
if (ta.scrollHeight > ta.clientHeight) ta.style.overflow = 'auto';
}
}
this.mouseClicked = function (e) {
selected = e.data.that.getSelectedText();
$('.popover-copy').popover('dispose');
if (selected.text.length && (e.data.that.selection === null || e.data.that.selection.text !== selected.text)) {
e.data.that.selection = selected;
var quoteParams = {
placement:'right',
trigger:'manual',
animation:false,
html:true,
container:'#chat-id-'+e.data.chat_id,
template : '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>',
content:function(){return '<a href="#" id="copy-popover-'+e.data.chat_id+'" ><i class="material-icons">&#xE244;</i>'+confLH.transLation.quote+'</a>'; }
}
var placement = typeof $(this).attr('id') !== 'undefined' ? '#messagesBlock-'+e.data.chat_id+' > #msg-'+$(this).attr('id').replace('msg-','')+' > .msg-body' : this;
var containerPopover = $(placement);
if (containerPopover.length == 0) return ;
ee.emitEvent('quoteAction', [quoteParams,e.data.chat_id]);
containerPopover.popover(quoteParams).popover('show').addClass('popover-copy');
$('#copy-popover-'+e.data.chat_id).click(function(){
lhinst.quateSelection(e.data.chat_id);
});
e.data.that.popoverShown = true;
e.data.that.popoverShownNow = true;
} else {
e.data.that.selection = null;
}
}
this.addScrollHandler = function(id) {
const child = document.getElementById('debug-message-' + id);
child.addEventListener('wheel', (e) => {
if (e.altKey) {
return;
}
e.preventDefault();
const parent = child.closest('.msgBlock-admin,.msgBlock-preview');
if (parent) parent.scrollTop += e.deltaY;
}, { passive: false });
}
this.addQuateHandler = function(chat_id)
{
this.popoverShown = false;
$('#messagesBlock-'+chat_id+' > .message-row:not([qt])')
.on('mouseup',{chat_id:chat_id, that : this}, lhinst.mouseClicked)
.on('contextmenu', {chat_id:chat_id, that : this}, lhinst.mouseContextMenu).attr('qt',1);
}
this.getSelectedTextPlain = function() {
var textToPaste = this.selection.text.replace(/[\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA]/g,'');
textToPaste = textToPaste.replace(/^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}(.*)/gm,'');
textToPaste = textToPaste.replace(/^[0-9]{2}:[0-9]{2}:[0-9]{2}(.*)/gm,'');
textToPaste = textToPaste.replace(/^\s*\n/gm, "");
textToPaste = textToPaste.replace(/^ /gm, "");
return textToPaste;
}
this.quateSelection = function (chat_id) {
$('.popover-copy').popover('dispose');
var textToPaste = this.getSelectedTextPlain();
window.textreplace = textToPaste;
this.insertTextToMessageArea(chat_id, textToPaste);
this.popoverShown = false;
};
this.hidePopover = function () {
if (this.popoverShownNow === true) {
this.popoverShownNow = false;
} else {
if (this.popoverShown === true) {
this.popoverShown = false;
$('.popover-copy').popover('dispose');
}
}
};
this.logOpenTrace = [];
this.addOpenTrace = function(log) {
this.logOpenTrace.push(log);
}
this.animateClick = function(chat_id) {
$('#chat-tab-link-'+chat_id).addClass('blink-tab-item');
setTimeout(function() {
$('#chat-tab-link-'+chat_id).removeClass('blink-tab-item');
}, 1000);
}
this.addTab = function(tabs, url, name, chat_id, focusTab, position) {
if (tabs.find('#chat-tab-link-'+chat_id).length > 0) {
lhinst.logOpenTrace = [];
this.animateClick(chat_id);
return ;
}
var hideTabs = confLH.hide_tabs && document.getElementById('tabs-dashboard') !== null ? ' d-none' : '';
var contentLi = '<li role="presentation" id="chat-tab-li-'+chat_id+'" class="nav-item'+hideTabs+'"><span onclick="return lhinst.removeDialogTab('+chat_id+',$(\'#tabs\'),true)" class="material-icons icon-close-chat">close</span><a class="nav-link chat-nav-item" href="#chat-id-'+chat_id+'" id="chat-tab-link-'+chat_id+'" aria-controls="chat-id-'+chat_id+'" role="tab" data-bs-toggle="tab"><i id="msg-send-status-'+chat_id+'" class="material-icons send-status-icon icon-user-online">send</i><i id="user-chat-status-'+chat_id+'" class="chat-tab-content '+this.tabIconClass+'">'+this.tabIconContent+'</i><span class="ntab" id="ntab-chat-'+chat_id+'">' + name.replace(/</g,'&lt;').replace(/>/g,'&gt;') + '</span></a></li>';
if (typeof position === 'undefined' || parseInt(position) == 0) {
tabs.find('> ul').append(contentLi);
} else {
tabs.find('> ul > li:eq('+ (position - 1)+')').after(contentLi);
};
$('#chat-tab-link-'+chat_id).click(function() {
history.pushState(null, null, '#chat-id-'+chat_id);
lhinst.previous_chat_id > 0 && $('#unread-separator-'+lhinst.previous_chat_id).remove();
lhinst.previous_chat_id = chat_id;
setTimeout(function() {
lhinst.setFocus(chat_id);
},2);
var inst = $(this);
setTimeout(function(){
inst.find('.msg-nm').remove();
var scrollNeeded = false;
if (inst.hasClass('has-pm')) {
scrollNeeded = true;
inst.removeClass('has-pm');
}
if (scrollNeeded == true) {
$('#messagesBlock-'+chat_id).prop('scrollTop',$('#messagesBlock-'+chat_id).prop('scrollHeight'));
}
},500);
ee.emitEvent('chatTabClicked', [chat_id, inst]);
});
var hash = window.location.hash.replace('#/','#');
var inst = this;
var logOpen = '';
if (lhinst.logOpenTrace.length > 0) {
logOpen = '/(ol)/' + lhinst.logOpenTrace.join('/');
lhinst.logOpenTrace = [];
}
$.get(url + logOpen, function(data) {
if (data == '') {
inst.removeDialogTab(chat_id,tabs,true);
return;
}
if ((typeof focusTab === 'undefined' || focusTab === true || hash == '#chat-id-'+chat_id) && url.indexOf('(arg)/backgroundid') === -1) {
tabs.find('> ul > li > a.active').removeClass("active");
tabs.find('> ul > #chat-tab-li-'+chat_id+' > a').addClass("active");
tabs.find('> div.tab-content > div.active').removeClass('active');
tabs.find('> div.tab-content').append('<div role="tabpanel" class="tab-pane active chat-tab-pane" id="chat-id-'+chat_id+'"></div>');
window.location.hash = '#/chat-id-'+chat_id;
tabs.addClass('chat-tab-selected');
} else {
tabs.find('> div.tab-content').append('<div role="tabpanel" class="tab-pane chat-tab-pane" id="chat-id-'+chat_id+'"></div>');
}
$('#chat-id-'+chat_id).html(data);
if (typeof focusTab === 'undefined' || focusTab === true || hash == '#chat-id-'+chat_id) {
inst.setFocus(chat_id);
}
if (inst.disableremember == false) {
inst.rememberTab(chat_id);
}
inst.addQuateHandler(chat_id);
inst.loadMainData(chat_id);
ee.emitEvent('chatTabLoaded', [chat_id]);
});
};
this.rememberTab = function(chat_id) {
if (localStorage) {
try{
chat_id = parseInt(chat_id);
var achat_id = localStorage.getItem('achat_id');
var achat_id_array = new Array();
if (achat_id !== null) {
var achat_id_array = achat_id.split(',').map(Number);
}
if (achat_id_array.indexOf(chat_id) === -1) {
achat_id_array.push(chat_id);
}
localStorage.setItem('achat_id',achat_id_array.join(','));
} catch (e) {
console.log(e);
}
}
};
this.forgetChat = function (chat_id,listId) {
if (localStorage) {
try {
chat_id = parseInt(chat_id);
var achat_id = localStorage.getItem(listId);
var achat_id_array = new Array();
if (achat_id !== null) {
achat_id_array = achat_id.split(',').map(Number);
}
if (achat_id_array.indexOf(chat_id) !== -1){
achat_id_array.splice(achat_id_array.indexOf(chat_id), 1);
}
localStorage.setItem(listId,achat_id_array.join(','));
} catch (e) {
console.log(e);
}
}
};
this.attachTabNavigator = function() {
$('#tabs > ul.nav > li > a').click(function(){
$(this).find('.msg-nm').remove();
$(this).removeClass('has-pm');
});
};
this.holdAction = function(chat_id, inst) {
var textArea = $("#CSChatMessage-"+chat_id);
if (textArea.is("[readonly]")) {
return;
}
var _this  = this;
$.postJSON(this.wwwDir + 'chat/holdaction/' + chat_id ,{'sel' : inst.hasClass('btn-outline-info'), 'op' : inst.attr('data-type') }, function(data) {
if (data.error == false) {
if (data.hold == true) {
inst.addClass('btn-outline-info');
if (inst.attr('data-type') == 'usr') {
$('#hold-action-'+chat_id).removeClass('btn-outline-info');
} else {
$('#hold-action-usr-'+chat_id).removeClass('btn-outline-info');
}
} else {
inst.removeClass('btn-outline-info');
}
if (data.msg != '') {
$('#messagesBlock-'+chat_id).append(data.msg).scrollTop($("#messagesBlock-"+chat_id).prop("scrollHeight"));
}
_this.syncadmincall();
} else {
alert(data.msg);
}
});
},
this.copyContent = function(inst){
var textArea = document.createElement("textarea");
var copyContent = '';
if (inst.attr('data-copy-id')) {
var sourceElement = document.getElementById(inst.attr('data-copy-id'));
if (sourceElement) {
copyContent = sourceElement.value || sourceElement.innerHTML;
}
} else {
copyContent = inst.attr('data-copy');
}
textArea.value = copyContent;
textArea.style.top = "0";
textArea.style.left = "0";
textArea.style.position = "fixed";
document.body.appendChild(textArea);
textArea.focus();
textArea.select();
try {
var successful = document.execCommand('copy');
} catch (err) {
alert('Oops, unable to copy');
}
document.body.removeChild(textArea);
var toolTip = new bootstrap.Tooltip(inst,{
trigger: 'click',
placement: 'top'
});
function setTooltip(message) {
toolTip.show();
}
function hideTooltip() {
setTimeout(function() {
toolTip.dispose();
}, 1000);
}
setTooltip();
hideTooltip();
},
this.copyMessages = function(inst) {
$('#chat-copy-messages').select();
document.execCommand("copy");
inst.tooltip({
trigger: 'click',
placement: 'top'
});
function setTooltip(message) {
inst.tooltip('hide')
.attr('data-original-title', message)
.tooltip('show');
}
function hideTooltip() {
setTimeout(function() {
inst.tooltip('hide');
}, 3000);
}
setTooltip(inst.attr('data-success'));
hideTooltip();
return false;
},
this.removeDialogTabGroup = function(chat_id, tabs)
{
ee.emitEvent('unloadGroupChat', [chat_id]);
var location = this.smartTabFocus(tabs, chat_id);
};
this.removeDialogTabMail = function(chat_id, tabs, hidetabs, internal)
{
!internal && this.channel && this.channel.postMessage({'action':'close_mail','args':{'mail_id' : chat_id}});
ee.emitEvent('unloadMailChat', [chat_id]);
var location = this.smartTabFocus(tabs, chat_id);
setTimeout(function() {
history.replaceState(null, null, location.replace('#/','#'));
},500);
};
this.addGroupTab = function(tabs, name, chat_id, background) {
if (tabs.find('#chat-tab-link-'+chat_id).length > 0) {
tabs.find('> ul > li > a.active').removeClass("active");
tabs.find('> ul > li#chat-tab-li-'+chat_id+' > a').addClass("active");
tabs.find('> div.tab-content > div.active').removeClass('active');
tabs.find('> div.tab-content > #chat-id-'+chat_id).addClass('active');
ee.emitEvent('groupChatTabClicked', [chat_id]);
return ;
}
var contentLi = '<li role="presentation" id="chat-tab-li-'+chat_id+'" class="nav-item"><a class="nav-link" href="#chat-id-'+chat_id+'" id="chat-tab-link-'+chat_id+'" aria-controls="chat-id-'+chat_id+'" role="tab" data-bs-toggle="tab"><i id="msg-send-status-'+chat_id+'" class="material-icons send-status-icon icon-user-online">send</i><i class="whatshot blink-ani d-none text-warning material-icons">whatshot</i><i id="user-chat-status-'+chat_id+'" class="'+this.tabIconClass+'">group</i><span class="ntab" id="ntab-chat-'+chat_id+'">' + name.replace(/</g,'&lt;').replace(/>/g,'&gt;') + '</span><span onclick="return lhinst.removeDialogTabGroup(\''+chat_id+'\',$(\'#tabs\'),true)" class="material-icons icon-close-chat">close</span></a></li>';
tabs.find('> ul').append(contentLi);
var hash = window.location.hash.replace('#/','#');
var inst = this;
if (background !== true) {
tabs.find('> ul > li > a.active').removeClass("active");
tabs.find('> ul > #chat-tab-li-'+chat_id+' > a').addClass("active");
tabs.find('> div.tab-content > div.active').removeClass('active');
tabs.find('> div.tab-content').append('<div role="tabpanel" class="tab-pane chat-tab-pane active" id="chat-id-'+chat_id+'"></div>');
} else {
tabs.find('> div.tab-content').append('<div role="tabpanel" class="tab-pane chat-tab-pane" id="chat-id-'+chat_id+'"></div>');
}
ee.emitEvent('groupChatTabLoaded', [chat_id]);
$('#chat-tab-link-'+chat_id).click(function() {
ee.emitEvent('groupChatTabClicked', [chat_id.replace('gc','')]);
});
};
this.addMailTab = function(tabs, name, chat_id, background) {
if (tabs.find('#chat-tab-link-'+chat_id).length > 0) {
if (background !== true) {
tabs.find('> ul > li > a.active').removeClass("active");
tabs.find('> ul > li#chat-tab-li-'+chat_id+' > a').addClass("active");
tabs.find('> div.tab-content > div.active').removeClass('active');
tabs.find('> div.tab-content > #chat-id-'+chat_id).addClass('active');
} else {
this.animateClick(chat_id);
}
ee.emitEvent('mailChatTabClicked', [chat_id.replace('mc','')]);
return ;
}
var contentLi = '<li role="presentation" id="chat-tab-li-'+chat_id+'" class="nav-item"><span onclick="return lhinst.removeDialogTabMail(\''+chat_id+'\',$(\'#tabs\'),true)" class="material-icons icon-close-chat">close</span><a class="nav-link" href="#chat-id-'+chat_id+'" id="chat-tab-link-'+chat_id+'" aria-controls="chat-id-'+chat_id+'" role="tab" data-bs-toggle="tab"><i id="msg-send-status-'+chat_id+'" class="material-icons send-status-icon icon-user-online">send</i><i class="whatshot blink-ani d-none text-warning material-icons">whatshot</i><i id="user-chat-status-'+chat_id+'" class="'+this.tabIconClass+'">mail_outline</i><span class="ntab" id="ntab-chat-'+chat_id+'">' + name.replace(/</g,'&lt;').replace(/>/g,'&gt;') + '</span></a></li>';
tabs.find('> ul').append(contentLi);
var hash = window.location.hash.replace('#/','#');
var inst = this;
if (background !== true) {
tabs.find('> ul > li > a.active').removeClass("active");
tabs.find('> ul > #chat-tab-li-'+chat_id+' > a').addClass("active");
tabs.find('> div.tab-content > div.active').removeClass('active');
tabs.find('> div.tab-content').append('<div role="tabpanel" class="tab-pane active" id="chat-id-'+chat_id+'"></div>');
window.location.hash = '#chat-id-'+chat_id;
} else {
tabs.find('> div.tab-content').append('<div role="tabpanel" class="tab-pane" id="chat-id-'+chat_id+'"></div>');
}
ee.emitEvent('mailChatTabLoaded', [chat_id, {'background' : background}]);
$('#chat-tab-link-'+chat_id).click(function() {
history.pushState(null, null, '#chat-id-'+chat_id);
ee.emitEvent('mailChatTabClicked', [chat_id.replace('mc','')]);
});
};
this.startGroupChat = function (chat_id, tabs, name, background) {
this.addGroupTab(tabs, name, 'gc'+chat_id, background);
}
this.startMailChat = function (chat_id, tabs, name, background) {
this.hideNotification(chat_id,'mail');
this.addMailTab(tabs, name, 'mc'+chat_id, background);
}
this.hideShowAction = function(options) {
var messagesBlock = $('#messagesBlock-' + options['chat_id']);
var needScroll = (messagesBlock.prop('scrollTop') + messagesBlock.height() + 30) > messagesBlock.prop('scrollHeight')
var msg = $('#message-more-'+options['id']);
if (msg.hasClass('hide')) {
msg.removeClass('hide');
options['hide_show'] == false ? $('#hide-show-action-'+options['id']).remove() : $('#hide-show-action-'+options['id']).text(options['hide_text']);
} else {
msg.addClass('hide');
if (options['hide_show'] == true) {
$('#hide-show-action-'+options['id']).text(options['show_text']);
}
}
needScroll && messagesBlock.scrollTop(messagesBlock.prop('scrollHeight'));
}
this.buttonAction = function(inst,payload) {
var row = inst.closest('.message-row');
$.getJSON(this.wwwDir + 'chat/abstractclick/' + row.attr('id').replace('msg-','') + '/' + payload, function(data) {
if (data.error) {
alert(data.error);
} else if (data.replace_id && data.html) {
var messagesBlock = $('#messagesBlock-' + data.chat_id);
var needScroll = (messagesBlock.prop('scrollTop') + messagesBlock.height() + 30) > messagesBlock.prop('scrollHeight');
$(data.replace_id).replaceWith(data.html);
lhinst.addQuateHandler(data.chat_id);
needScroll && messagesBlock.scrollTop(messagesBlock.prop('scrollHeight'));
} else if (data.modal) {
lhc.revealModal({'url':WWW_DIR_JAVASCRIPT+data.modal});
}
});
}
this.startChat = function (chat_id,tabs,name,focusTab,position) {
this.removeBackgroundChat(chat_id);
this.hideNotification(chat_id);
$('#sub-tabs').length > 0 && $('#sub-tabs a[href=\'#sub-tabs-open\']').tab('show');
var focusTabAction = typeof focusTab !== 'undefined' ? focusTab : true;
if ( this.chatUnderSynchronization(chat_id) == false ) {
var rememberAppend = this.disableremember == false ? '/(remember)/true' : '';
this.addTab(tabs, this.wwwDir +'chat/adminchat/'+chat_id+rememberAppend, name, chat_id, focusTabAction, position);
var inst = this;
if (this.ignoreAdminSync === false) {
setTimeout(function() {
inst.syncadmininterfacestatic();
},1000);
}
} else {
if (focusTabAction) {
tabs.find('> ul > li > a.active').removeClass("active");
tabs.find('> ul > li#chat-tab-li-'+chat_id+' > a').addClass("active");
tabs.find('> div.tab-content > div.active').removeClass('active');
tabs.find('> div.tab-content > #chat-id-'+chat_id).addClass('active');
} else {
this.animateClick(chat_id);
}
window.location.hash = '#/chat-id-'+chat_id;
}
ee.emitEvent('chatStartTab', [chat_id, {name: name, focus: (typeof focusTab !== 'undefined' ? focusTab : true), position: position}]);
};
this.backgroundChats = [];
this.startChatBackground = function (chat_id,tabs,name,backgroundType) {
if ( this.chatUnderSynchronization(chat_id) == false ) {
this.backgroundChats.push(parseInt(chat_id));
var rememberAppend = this.disableremember == false ? '/(remember)/true' : '';
if (!backgroundType) {
backgroundType = 'background';
}
this.addTab(tabs, this.wwwDir +'chat/adminchat/'+chat_id+rememberAppend+'/(arg)/'+backgroundType, name, chat_id, false);
ee.emitEvent('chatStartBackground', [chat_id,{name:name}]);
return true;
}
return false;
};
this.protectCSFR = function()
{
$('a.csfr-required').click(function(event) {
var inst = $(this);
if (!inst.attr('data-secured')){
inst.attr('href',inst.attr('href')+'/(csfr)/'+confLH.csrf_token);
inst.attr('data-secured',1);
}
if (inst.hasClass('csfr-post') && !inst.hasClass('csfr-post-executed')) {
event.preventDefault();
event.stopPropagation();
inst.addClass('csfr-post-executed');
if (inst.attr('data-trans')) {
lhc.revealModal({'url': WWW_DIR_JAVASCRIPT + 'system/confirmdialog', 'backdrop':true,
'hidecallback' : function(){
inst.removeClass('csfr-post-executed');
},
'showcallback' : function(){
$('#confirm-button-action').click(function(event) {
$.post(inst.attr('href'), function(data) {
if (inst.attr('data-ajax-confirm') === 'true') {
if (typeof data.error !== 'undefined' && data.error == false) {
document.location.reload();
} else {
$('#confirm-dialog-content').html(data.result);
}
} else if (inst.attr('data-ajax-remove')) {
$('#'+inst.attr('data-ajax-remove')).fadeOut();
$('#myModal').modal('hide');
} else {
if (typeof data === 'object' && data !== null) {
if (data.location && typeof data.location === 'string') {
window.location.href = data.location;
} else {
document.location.reload();
}
} else {
document.location.reload();
}
}
}).fail(function(e){
document.location.reload();
});
});
}});
} else {
$.post(inst.attr('href'), function(){
document.location.reload();
}).fail(function(){
document.location.reload();
});
}
}
});
};
this.addSynchroChat = function (chat_id,message_id)
{
this.chatsSynchronising.push(chat_id);
this.chatsSynchronisingMsg.push(chat_id + ',' +message_id);
if (LHCCallbacks.addSynchroChat) {
LHCCallbacks.addSynchroChat(chat_id,message_id);
}
};
this.removeSynchroChat = function (chat_id, passive)
{
var j = 0;
while (j < this.chatsSynchronising.length) {
if (this.chatsSynchronising[j] == chat_id) {
this.chatsSynchronising.splice(j, 1);
this.chatsSynchronisingMsg.splice(j, 1);
} else { j++; }
};
this.forgetChat(chat_id,'achat_id');
if (passive !== true) {
ee.emitEvent('removeSynchroChat', [chat_id]);
}
if (LHCCallbacks.removeSynchroChat) {
LHCCallbacks.removeSynchroChat(chat_id);
}
};
this.is_typing = false;
this.typing_timeout = null;
this.operatorTypingCallback = function(chat_id)
{
var www_dir = this.wwwDir;
var inst = this;
if (inst.is_typing == false) {
inst.is_typing = true;
clearTimeout(inst.typing_timeout);
if (inst.nodeJsMode == true) {
inst.typing_timeout = setTimeout(function(){inst.typingStoppedOperator(chat_id);},3000);
ee.emitEvent('operatorTyping', [{'chat_id':chat_id,'status':true}]);
} else {
$.getJSON(www_dir + 'chat/operatortyping/' + chat_id+'/true',{ }, function(data){
inst.typing_timeout = setTimeout(function(){inst.typingStoppedOperator(chat_id);},3000);
if (LHCCallbacks.initTypingMonitoringAdmin) {
LHCCallbacks.initTypingMonitoringAdmin(chat_id,true);
}
}).fail(function(){
inst.typing_timeout = setTimeout(function(){inst.typingStoppedOperator(chat_id);},3000);
});
}
} else {
clearTimeout(inst.typing_timeout);
inst.typing_timeout = setTimeout(function(){inst.typingStoppedOperator(chat_id);},3000);
}
};
this.initTypingMonitoringAdmin = function(chat_id) {
var inst = this;
let editor = jQuery('#CSChatMessage-'+chat_id);
if (editor.prop('nodeName') != 'LHC-EDITOR') {
editor.bind('keyup', function (evt){
inst.operatorTypingCallback(chat_id);
});
}
};
this.remarksTimeout = null;
this.saveRemarks = function(chat_id) {
clearTimeout(this.remarksTimeout);
$('#remarks-status-'+chat_id).addClass('text-warning');
$('#main-user-info-remarks-'+chat_id+' .alert').remove();
var inst = this;
this.remarksTimeout = setTimeout(function() {
$.postJSON(inst.wwwDir + 'chat/saveremarks/' + chat_id,{'data':$('#ChatRemarks-'+chat_id).val()}, function(data) {
if (data.error == 'false') {
$('#remarks-status-'+chat_id).removeClass('text-warning');
} else {
$('#main-user-info-remarks-'+chat_id).prepend(data.result);
}
});
},500);
};
this.reaction = function(inst) {
$.postJSON(this.wwwDir + 'chat/reaction/' + inst.attr('data-msg-id'), {'identifier' :inst.attr('data-identifier'), 'data': + inst.attr('data-value')}, function(data) {
if (data.error == 'false') {
$('#reaction-message-info-'+inst.attr('data-msg-id')).remove();
$('#reaction-message-'+inst.attr('data-msg-id')).replaceWith(data.result);
} else {
alert(data.result);
}
});
}
this.saveNotes = function(chat_id) {
clearTimeout(this.remarksTimeout);
$('#remarks-status-online-'+chat_id).addClass('text-warning');
var inst = this;
this.remarksTimeout = setTimeout(function(){
$.postJSON(inst.wwwDir + 'chat/saveonlinenotes/' + chat_id,{'data':$('#OnlineRemarks-'+chat_id).val()}, function(data){
$('#remarks-status-online-'+chat_id).removeClass('text-warning');
});
},500);
};
this.surveyShowed = false;
this.typingStoppedOperator = function(chat_id) {
var inst = this;
if (inst.is_typing == true){
if (lhinst.nodeJsMode  == true) {
inst.is_typing = false;
ee.emitEvent('operatorTyping', [{'chat_id':chat_id,'status':false}]);
} else {
$.getJSON(this.wwwDir + 'chat/operatortyping/' + chat_id+'/false',{ }, function(data){
inst.is_typing = false;
if (LHCCallbacks.initTypingMonitoringAdmin) {
LHCCallbacks.initTypingMonitoringAdmin(chat_id,false);
};
}).fail(function(){
inst.is_typing = false;
});
}
}
};
this.refreshFootPrint = function(inst) {
inst.addClass('disabled');
$.get(this.wwwDir + 'chat/chatfootprint/' + inst.attr('rel'),{ }, function(data){
$('#footprint-'+inst.attr('rel')).html(data);
inst.removeClass('disabled');
});
};
this.makeAbstractRequest = function(chat_id, inst) {
$.get(inst.attr('href'), function(data) {
lhinst.syncadmininterfacestatic();
if (LHCCallbacks.userRedirectedSurvey) {
LHCCallbacks.userRedirectedSurvey(chat_id);
};
});
return false;
};
this.refreshOnlineUserInfo = function(inst) {
inst.addClass('disabled');
$.get(this.wwwDir + 'chat/refreshonlineinfo/' + inst.attr('rel'),{ }, function(data){
$('#online-user-info-'+inst.attr('rel')).html(data);
inst.removeClass('disabled');
});
};
this.processCollapse = function(chat_id)
{
if ($('#chat-main-column-'+chat_id+' .collapse-right').text() == 'chevron_right'){
$('#chat-right-column-'+chat_id).hide();
$('#chat-main-column-'+chat_id).removeClass('col-md-8').addClass('col-md-12');
$('#chat-main-column-'+chat_id+' .collapse-right').text('chevron_left');
try {
if (localStorage) {
localStorage.setItem('lhc_rch',1);
}
} catch(e) {}
} else {
$('#chat-right-column-'+chat_id).show();
$('#chat-main-column-'+chat_id).removeClass('col-md-12').addClass('col-md-8');
$('#chat-main-column-'+chat_id+' .collapse-right').text('chevron_right');
try {
if (localStorage) {
localStorage.removeItem('lhc_rch');
}
} catch(e) {}
};
};
this.chatUnderSynchronization = function(chat_id)
{
var j = 0;
while (j < this.chatsSynchronising.length) {
if (this.chatsSynchronising[j] == chat_id) {
return true;
} else { j++; }
}
return false;
};
this.getChatIndex = function(chat_id)
{
var j = 0;
while (j < this.chatsSynchronising.length) {
if (this.chatsSynchronising[j] == chat_id) {
return j;
} else { j++; }
}
return false;
};
this.closeActiveChatDialog = function(chat_id, tabs, hidetab, ignoreRelated)
{
var that = this;
var attribute = '{}';
let editor = $('#CSChatMessage-'+chat_id);
editor.length != 0 && (attribute = editor.attr('related-actions'));
if (editor.length != 0 && editor.attr('close-related') !== "false" && !ignoreRelated) {
var clsAction = $('#chat-close-action-'+chat_id);
clsAction.find('.close-text').text(clsAction.attr('data-loading')).parent().find('.material-icons').text('sync').addClass('lhc-spin');
lhc.revealModal({
'url': WWW_DIR_JAVASCRIPT+'chat/relatedactions/'+chat_id,
'loadmethod' : 'post',
'datapost' : attribute,
'backdrop': true,
'hidecallback' : function() {
clsAction.find('.close-text').text(clsAction.find('.close-text').attr('data-original')).parent().find('.material-icons').text('close').removeClass('lhc-spin');
},
'on_empty': function() {
that.closeActiveChatDialog(chat_id, tabs, hidetab, true); // If no related actions close it instantly
}
});
return;
}
ee.emitEvent('angularSyncDisabled', [true]);
$.postJSON(this.wwwDir + this.closechatadmin + chat_id, attribute, function (data) {
ee.emitEvent('angularSyncDisabled', [false]);
if (data.error == false) {
ee.emitEvent('angularLoadChatList');
} else {
alert(data.result);
ee.emitEvent('angularStartChatbyId',[chat_id]);
}
$('#myModal').modal('hide');
if (hidetab == true && that.closeWindowOnChatCloseDelete == true) {
window.close();
}
}).fail(function(jqXHR, textStatus, errorThrown) {
ee.emitEvent('angularSyncDisabled', [false]);
alert('There was an error processing your request: ' + '[' + jqXHR.status + '] [' + jqXHR.statusText + '] [' + jqXHR.responseText + '] ' + errorThrown);
ee.emitEvent('angularStartChatbyId',[chat_id]);
});
if (editor.length != 0 && editor.prop('nodeName') != 'LHC-EDITOR') {
editor.unbind('keydown', function(){});
editor.unbind('keyup', function(){});
};
if (!!window.postMessage && window.opener) {
window.opener.postMessage("lhc_ch:chatclosed:"+chat_id, '*');
};
that.channel && that.channel.postMessage({'action':'close_chat','args':{'chat_id' : chat_id}});
that.removeSynchroChat(chat_id);
if (hidetab == true) {
var location = that.smartTabFocus(tabs, chat_id);
setTimeout(function() {
history.replaceState(null, null, location.replace('#/','#'));
},500);
};
if (LHCCallbacks.chatClosedCallback) {
LHCCallbacks.chatClosedCallback(chat_id);
};
};
this.smartTabFocus = function(tabs, chat_id, params) {
var index = tabs.find('> ul > #chat-tab-li-'+chat_id).index();
if (!params) {params = {};}
var navigationDirection = (params.up == true || typeof params.up == 'undefined') ? 1 : -1;
if (!params['keep']) {
tabs.find('> ul > #chat-tab-li-'+chat_id).remove();
tabs.find('#chat-id-'+chat_id).remove();
} else {
tabs.find('> ul > li > a.active').removeClass('active');
}
var linkTab = tabs.find('> ul > li:eq('+ (index - navigationDirection)+')');
if (linkTab.attr('id') !== undefined) {
var link = linkTab.find('> a');
} else {
linkTabRight = tabs.find('> ul > li:eq('+ (index) + ')');
if (linkTabRight.length > 0) {
var link = linkTabRight.find('> a');
} else {
var link = linkTab.find('> a');
}
}
if (!tabs.find('> ul > li > a.active').length) {
var moveLeft = true;
var navigator = 1;
while (moveLeft) {
if (!link.hasClass('non-focus')) {
moveLeft = false;
} else {
moveLeft = true;
var prevElement = link.parent().prev();
if (prevElement.find(' > a').length) {
link = prevElement.find(' > a');
}
}
}
link.tab('show');
if (link.attr('id') !== undefined) {
var new_chat_id = link.attr('href').replace('#chat-id-','');
this.removeBackgroundChat(new_chat_id);
this.hideNotification(new_chat_id);
if (!params['keep']) {
ee.emitEvent('chatTabFocused', [new_chat_id]);
}
}
}
if (link.attr('href') !== undefined) {
return link.attr('href').replace('#','#/');
} else {
return '#';
}
};
this.startChatCloseTabNewWindow = function(chat_id, tabs, name)
{
window.open(this.wwwDir + 'chat/single/'+chat_id,'chatwindow-chat-id-'+chat_id,"menubar=1,resizable=1,width=800,height=650");
this.smartTabFocus(tabs, chat_id);
if (this.closeWindowOnChatCloseDelete == true)
{
window.close();
};
this.removeSynchroChat(chat_id);
this.syncadmininterfacestatic();
return false;
};
this.removeDialogTab = function(chat_id, tabs, hidetab)
{
this.channel && this.chatUnderSynchronization(chat_id) === true && this.channel.postMessage({'action':'close_chat','args':{'chat_id' : chat_id}});
let editor = $('#CSChatMessage-'+chat_id);
if (editor.length != 0 && editor.prop('nodeName') != 'LHC-EDITOR') {
editor.unbind('keydown', function(){});
editor.unbind('keyup', function(){});
}
this.removeSynchroChat(chat_id);
if (hidetab == true) {
var location = this.smartTabFocus(tabs, chat_id);
setTimeout(function() {
history.replaceState(null, null, location.replace('#/','#'));
},500);
if (this.closeWindowOnChatCloseDelete == true)
{
window.close();
};
};
this.syncadmininterfacestatic();
};
this.removeActiveDialogTag = function(tabs) {
if (this.closeWindowOnChatCloseDelete == true)
{
window.close();
};
};
this.deleteChat = function(chat_id, tabs, hidetab)
{
if (confirm(confLH.transLation.delete_confirm)) {
var that = this;
$.postJSON(this.wwwDir + this.deletechatadmin + chat_id, function(data){
if (data.error == true) {
alert(data.result);
} else {
let editor = $('#CSChatMessage-'+chat_id);
if (editor.length != 0 && editor.prop('nodeName') != 'LHC-EDITOR') {
editor.unbind('keydown', function(){});
editor.unbind('keyup', function(){});
}
that.removeSynchroChat(chat_id);
if (hidetab == true) {
var location = that.smartTabFocus(tabs, chat_id);
setTimeout(function() {
history.replaceState(null, null, location.replace('#/','#'));
},500);
if (that.closeWindowOnChatCloseDelete == true)
{
window.close();
}
};
if (LHCCallbacks.chatDeletedCallback) {
LHCCallbacks.chatDeletedCallback(chat_id);
};
that.syncadmininterfacestatic();
}
}).fail(function(jqXHR, textStatus, errorThrown) {
console.dir(jqXHR);
alert('getJSON request failed! ' + textStatus + ':' + errorThrown + ':' + jqXHR.responseText);
});
}
};
this.rejectPendingChat = function(chat_id, tabs)
{
var that = this;
$.postJSON(this.wwwDir + this.deletechatadmin + chat_id ,{}, function(data){
that.syncadmininterfacestatic();
}).fail(function(jqXHR, textStatus, errorThrown) {
console.dir(jqXHR);
alert('getJSON request failed! ' + textStatus + ':' + errorThrown + ':' + jqXHR.responseText);
});
};
this.startChatNewWindow = function(chat_id,name)
{
var popupWindow = window.open(this.wwwDir + 'chat/single/'+chat_id,'chatwindow-chat-id-'+chat_id,"menubar=1,resizable=1,width=800,height=650");
if (popupWindow !== null) {
popupWindow.focus();
var inst = this;
setTimeout(function(){
inst.syncadmininterfacestatic();
},1000);
ee.emitEvent('chatStartOpenWindow', [chat_id]);
}
};
this.startMailNewWindow = function(chat_id,name)
{
window.open(this.wwwDir + 'mailconv/single/'+chat_id,'mailwindow-chat-id-'+chat_id,"menubar=1,resizable=1,width=900,height=650").focus();
var inst = this;
setTimeout(function(){
inst.syncadmininterfacestatic();
},1000);
};
this.startChatNewWindowArchive = function(archive_id, chat_id,name)
{
var popupWindow = window.open(this.wwwDir + 'chatarchive/viewarchivedchat/' + archive_id + '/' + chat_id + '/(mode)/popup','chatwindow-chat-id-'+chat_id,"menubar=1,resizable=1,width=800,height=650");
if (popupWindow !== null) {
popupWindow.focus();
ee.emitEvent('chatStartOpenWindowArchive', [archive_id, chat_id]);
}
};
this.speechToText = function(chat_id)
{
if (this.speechHandler == false)
{
this.speechHandler = new LHCSpeechToText();
}
this.speechHandler.listen({'chat_id':chat_id});
};
this.startChatTransfer = function(chat_id,tabs,name,transfer_id, background) {
var inst = this;
$.getJSON(this.wwwDir + this.accepttransfer + transfer_id ,{}, function(data) {
if (data.scope == 1) {
inst.startMailChat(chat_id,tabs,name);
} else {
if ($('#chat-tab-link-' + chat_id).length == 0) {
if (background) {
inst.removeSynchroChat(chat_id);
inst.startChatBackground(chat_id,tabs,name)
} else {
inst.startChat(chat_id,tabs,name);
}
} else {
inst.updateVoteStatus(chat_id);
}
}
if (LHCCallbacks.operatorAcceptedTransfer) {
LHCCallbacks.operatorAcceptedTransfer(chat_id);
};
}).fail(function(){
inst.startChat(chat_id,tabs,name);
});
};
this.startChatNewWindowTransfer = function(chat_id, name, transfer_id, transfer_scope)
{
$.getJSON(this.wwwDir + this.accepttransfer + transfer_id ,{}, function(data){
if (LHCCallbacks.operatorAcceptedTransfer) {
LHCCallbacks.operatorAcceptedTransfer(chat_id);
};
});
if (transfer_scope == 1) {
return this.startMailNewWindow(chat_id,name);
} else {
return this.startChatNewWindow(chat_id,name);
}
};
this.startChatNewWindowTransferByTransfer = function(chat_id, nt, transferScope, background)
{
var inst = this;
$.ajax({
type: "GET",
url: this.wwwDir + this.accepttransfer + chat_id+'/(mode)/chat/(scope)/' + transferScope,
cache: false,
dataType: 'json'
}).done(function(data){
if ($('#tabs').length > 0) {
if (transferScope == 1) {
inst.startMailChat(data.chat_id, $('#tabs'), nt);
window.focus();
} else {
if (typeof background !== 'undefined' && background === true) {
inst.addOpenTrace('transfer_open_background');
inst.startChatBackground(data.chat_id, $('#tabs'), nt);
} else {
window.focus();
inst.addOpenTrace('transfer_open');
inst.startChat(data.chat_id, $('#tabs'), nt);
}
}
} else {
if (transferScope == 1) {
inst.startMailNewWindow(data.chat_id,'ChatMail');
} else {
inst.startChatNewWindow(data.chat_id,'');
}
}
if (LHCCallbacks.operatorAcceptedTransfer) {
LHCCallbacks.operatorAcceptedTransfer(data.chat_id);
};
});
this.syncadmininterfacestatic();
return false;
};
this.switchLang = function(form,lang){
var languageAppend = '<input type="hidden" value="'+lang+'" name="switchLang" />';
form.append(languageAppend);
form.submit();
return false;
};
this.sendLinkToMail = function( embed_code,file_id) {
var val = window.parent.$('#MailMessage').val();
window.parent.$('#MailMessage').val(((val != '') ? val+"\n" : val)+embed_code);
$('#embed-button-'+file_id).addClass('btn-success');
};
this.sendLinkToEditor = function(chat_id, embed_code,file_id) {
let editor = window.parent.$('#CSChatMessage-'+chat_id);
if (editor.prop('nodeName') == 'LHC-EDITOR') {
editor[0].insertContent(embed_code,{"new_line":true,"convert_bbcode" : true});
} else {
var val = editor.val();
editor.val(((val != '') ? val+"\n" : val)+embed_code);
$('#embed-button-'+file_id).addClass('btn-success');
}
};
this.sendLinkToGeneralEditor = function(embed_code,file_id, params) {
var editor = window.parent.$('.embed-into');
if (editor.length == 0) {
editor = window.opener.$('.embed-into');
};
if (typeof params !== 'undefined' && typeof params['replace'] !== `undefined` && params['replace'] == true){
if (editor.prop('nodeName') == 'LHC-EDITOR') {
editor[0].setContent(embed_code,{"convert_bbcode" : true});
} else {
editor.val(embed_code);
}
} else {
if (editor.prop('nodeName') == 'LHC-EDITOR') {
editor[0].insertContent(embed_code,{"new_line":true,"convert_bbcode" : true});
} else {
var val = editor.val();
editor.val(((val != '') ? val+"\n" : val)+embed_code);
}
}
$('#embed-button-'+file_id).addClass('btn-success');
};
this.hideOnTransferHappen = function(chat_id){
var inst = this;
var intervalChecker = setInterval( function() {
if (parseInt(confLH.user_id) != parseInt($('#chat-owner-'+chat_id).attr('user-id'))) {
if ($('#tabs').length > 0) {
inst.removeDialogTab(chat_id,$('#tabs'),true);
inst.channel && inst.channel.postMessage({'action':'close_chat','args':{'chat_id' : parseInt(chat_id)}});
}
clearInterval(intervalChecker);
}
},1000);
};
this.hideTransferModal = function(chat_id, obj)
{
var inst = this;
setTimeout(function(){
$('#myModal').modal('hide');
if ($('#tabs').length > 0) {
if (obj === 'mail') {
inst.removeDialogTabMail('mc'+chat_id,$('#tabs'),true)
} else {
inst.hideOnTransferHappen(chat_id);
}
} else {
if (obj === 'mail') {
ee.emitEvent('mailChatModified', [chat_id]);
}
}
},1000);
};
this.transferChatDep = function(chat_id, obj)
{
$('.transfer-action-button').attr('disabled','disabled');
var inst = this;
var user_id = $('[name=DepartamentID'+chat_id+']:checked').val();
$.postJSON(this.wwwDir + this.trasnsferuser + chat_id + '/' + user_id ,{'type':'dep', 'obj' : obj}, function(data){
if (data.error == 'false') {
$('#transfer-block-'+data.chat_id).html(data.result);
inst.hideTransferModal(chat_id, obj);
} else {
$('#transfer-block-'+chat_id).text(JSON.stringify(data));
};
$('.transfer-action-button').removeAttr('disabled');
}).fail(function(respose) {
var escaped = '<div style="margin:10px 10px 30px 10px;" class="alert alert-warning" role="alert">' + $("<div>").text('You have weak internet connection or the server has problems. Try to refresh the page or send the message again.' + (typeof respose.status !== 'undefined' ? ' Error code ['+respose.status+']' : '') + (typeof respose.responseText !== 'undefined' ? respose.responseText : '')).html() + '</div>';
$('#transfer-block-'+chat_id).html(escaped);
$('.transfer-action-button').removeAttr('disabled');
});
};
this.transferChat = function(chat_id, obj)
{
var inst = this;
var user_id = $('[name=TransferTo'+chat_id+']:checked').val();
$('.transfer-action-button').attr('disabled','disabled');
$.postJSON(this.wwwDir + this.trasnsferuser + chat_id + '/' + user_id ,{'type':'user', 'obj': obj}, function(data){
if (data.error == 'false') {
$('#transfer-block-'+data.chat_id).html(data.result);
inst.hideTransferModal(chat_id, obj);
} else {
$('#transfer-block-'+chat_id).text(JSON.stringify(data));
};
$('.transfer-action-button').removeAttr('disabled');
}).fail(function(respose) {
var escaped = '<div style="margin:10px 10px 30px 10px;" class="alert alert-warning" role="alert">' + $("<div>").text('You have weak internet connection or the server has problems. Try to refresh the page or send the message again.' + (typeof respose.status !== 'undefined' ? ' Error code ['+respose.status+']' : '') + (typeof respose.responseText !== 'undefined' ? respose.responseText : '')).html() + '</div>';
$('#transfer-block-'+chat_id).html(escaped);
$('.transfer-action-button').removeAttr('disabled');
});
};
this.changeOwner = function(chat_id, obj) {
var inst = this;
var user_id = $('#id_new_user_id').val();
$('.transfer-action-button').attr('disabled','disabled');
$.postJSON(this.wwwDir + this.trasnsferuser + chat_id + '/' + user_id, {'type' : 'change_owner','obj' : obj}, function(data){
if (data.error == 'false') {
$('#transfer-block-'+data.chat_id).html(data.result);
inst.hideTransferModal(chat_id, obj);
} else {
$('#transfer-block-'+chat_id).text(JSON.stringify(data));
};
$('.transfer-action-button').removeAttr('disabled');
}).fail(function(respose) {
var escaped = '<div style="margin:10px 10px 30px 10px;" class="alert alert-warning" role="alert">' + $("<div>").text('You have weak internet connection or the server has problems. Try to refresh the page or send the message again.' + (typeof respose.status !== 'undefined' ? ' Error code ['+respose.status+']' : '') + (typeof respose.responseText !== 'undefined' ? respose.responseText : '')).html() + '</div>';
$('#transfer-block-'+chat_id).html(escaped);
$('.transfer-action-button').removeAttr('disabled');
});
};
this.changeDep = function(chat_id, obj) {
var inst = this;
var user_id = $('#id_new_dep_id').val();
$('.transfer-action-button').attr('disabled','disabled');
$.postJSON(this.wwwDir + this.trasnsferuser + chat_id + '/' + user_id, {'type':'change_dep','obj' : obj}, function(data){
if (data.error == 'false') {
$('#transfer-block-'+data.chat_id).html(data.result);
$('#myModal').modal('hide');
if (obj === 'mail') {
ee.emitEvent('mailChatModified', [chat_id]);
} else {
inst.updateVoteStatus(chat_id);
}
} else {
$('#transfer-block-'+chat_id).text(JSON.stringify(data));
};
$('.transfer-action-button').removeAttr('disabled');
}).fail(function(respose) {
var escaped = '<div style="margin:10px 10px 30px 10px;" class="alert alert-warning" role="alert">' + $("<div>").text('You have weak internet connection or the server has problems. Try to refresh the page or send the message again.' + (typeof respose.status !== 'undefined' ? ' Error code ['+respose.status+']' : '') + (typeof respose.responseText !== 'undefined' ? respose.responseText : '')).html() + '</div>';
$('#transfer-block-'+chat_id).html(escaped);
$('.transfer-action-button').removeAttr('disabled');
});
};
this.chooseSurvey = function(chat_id)
{
var survey_id = $('[name=SurveyItem'+chat_id+']:checked').val();
$.postJSON(this.wwwDir + "survey/choosesurvey/" + chat_id + '/' + survey_id, function(data){
if (data.error == 'false') {
$('#survey-block-'+data.chat_id).html(data.result);
};
});
};
this.redirectContact = function(chat_id,message){
if (typeof message === 'undefined' || confirm(message)){
$.postJSON(this.wwwDir + 'chat/redirectcontact/' + chat_id, function(data){
lhinst.syncadmininterfacestatic();
if (LHCCallbacks.userRedirectedContact) {
LHCCallbacks.userRedirectedContact(chat_id);
};
});
}
};
this.redirectToURL = function(chat_id) {
lhc.revealModal({'url':WWW_DIR_JAVASCRIPT+'chat/singleaction/'+chat_id + '/redirecttourl'});
};
this.setAreaAttrByCheckbox = function(chat_id, action) {
var array = [];
var checkboxes = document.querySelectorAll('input[name='+action+'-'+chat_id+']:checked');
for (var i = 0; i < checkboxes.length; i++) {
array.push(checkboxes[i].value);
}
var attribute = $('#CSChatMessage-'+chat_id).attr('related-actions');
var attributeSet = {};
if (attribute) {
attributeSet = JSON.parse(attribute);
}
attributeSet[action] = array;
$('#CSChatMessage-'+chat_id).attr('related-actions', JSON.stringify(attributeSet));
}
this.explandCollapse = function (type, object_id, provider) {
var expandIcon = document.getElementById('expand-action-' + type + '-' + object_id);
expandIcon.innerText = expandIcon.innerText == 'expand_less' ? 'expand_more' : 'expand_less';
document.getElementById('lhc-list-' + type + '-' + object_id).style.display = expandIcon.innerText == 'expand_less' ? 'block' : 'none';
if (expandIcon.getAttribute('data-loaded') == 'false') {
expandIcon.setAttribute('data-loaded','true');
$.postJSON(this.wwwDir + provider, function(data) {
var elm = document.getElementById('lhc-list-' + type + '-' + object_id);
if (!elm) {
return;
}
elm.innerHTML = data.data;
});
}
};
this.redirectToURLOnline = function(online_user_id,trans) {
var url = prompt(trans, "");
if (url != null) {
lhinst.addRemoteOnlineCommand(online_user_id,'lhc_chat_redirect:'+url.replace(new RegExp(':','g'),'__SPLIT__'));
lhinst.addExecutionCommand(online_user_id,'lhc_cobrowse_multi_command__lhc_chat_redirect:'+url.replace(new RegExp(':','g'),'__SPLIT__'));
}
};
this.chatTabsOpen = function ()
{
window.open(this.wwwDir + 'chat/chattabs/','chatwindows',"menubar=1,resizable=1,width=800,height=650");
return false;
};
this.explicitClose = false;
this.sendCannedMessage = function(chat_id,link_inst)
{
if ($('#id_CannedMessage-'+chat_id).val() > 0) {
link_inst.addClass('secondary');
var delayMiliseconds = parseInt($('#id_CannedMessage-'+chat_id).find(':selected').attr('data-delay'))*1000;
var www_dir = this.wwwDir;
var inst  = this;
if (inst.is_typing == false) {
inst.is_typing = true;
clearTimeout(inst.typing_timeout);
if (LHCCallbacks.initTypingMonitoringAdminInform) {
LHCCallbacks.initTypingMonitoringAdminInform({'chat_id':chat_id,'status':true});
};
$.getJSON(www_dir + 'chat/operatortyping/' + chat_id+'/true',{ }, function(data){
if (LHCCallbacks.initTypingMonitoringAdmin) {
LHCCallbacks.initTypingMonitoringAdmin(chat_id,true);
};
inst.typing_timeout = setTimeout(function(){inst.typingStoppedOperator(chat_id);link_inst.removeClass('secondary');},(delayMiliseconds > 3000 ? delayMiliseconds : 3000));
}).fail(function(){
inst.typing_timeout = setTimeout(function(){inst.typingStoppedOperator(chat_id);},3000);
});
} else {
clearTimeout(inst.typing_timeout);
inst.typing_timeout = setTimeout(function(){inst.typingStoppedOperator(chat_id);},3000);
link_inst.removeClass('secondary');
};
if (delayMiliseconds > 0) {
setTimeout(function(){
var pdata = {
msg	: $('#id_CannedMessage-'+chat_id).find(':selected').attr('data-msg')
};
if ($('#CSChatMessage-'+chat_id).attr('mode-write')) {
pdata.mode_write = $('#CSChatMessage-'+chat_id).attr('mode-write');
}
let editor = $('#CSChatMessage-'+chat_id);
if (editor.prop('nodeName') == 'LHC-EDITOR') {
editor[0].setContent('');
} else {
editor.val('');
}
$.postJSON(www_dir + inst.addmsgurl + chat_id, pdata , function(data){
if (LHCCallbacks.addmsgadmin) {
LHCCallbacks.addmsgadmin(chat_id);
};
ee.emitEvent('chatAddMsgAdmin', [chat_id]);
lhinst.syncadmincall();
return true;
});
},delayMiliseconds);
} else {
var pdata = {
msg	: $('#id_CannedMessage-'+chat_id).find(':selected').attr('data-msg')
};
if ($('#CSChatMessage-'+chat_id).attr('mode-write')) {
pdata.mode_write = $('#CSChatMessage-'+chat_id).attr('mode-write');
}
let editor = $('#CSChatMessage-'+chat_id);
if (editor.prop('nodeName') == 'LHC-EDITOR') {
editor[0].setContent('');
} else {
editor.val('');
}
$.postJSON(this.wwwDir + this.addmsgurl + chat_id, pdata , function(data){
if (LHCCallbacks.addmsgadmin) {
LHCCallbacks.addmsgadmin(chat_id);
};
ee.emitEvent('chatAddMsgAdmin', [chat_id]);
lhinst.syncadmincall();
return true;
});
}
};
return false;
};
this.theme = null;
this.chatStatus = null;
this.survey = null;
this.isBlinking = false;
this.startBlinking = function(){
if (this.isBlinking == false) {
var inst = this;
var newExcitingAlerts = (function () {
var oldTitle = document.title;
var msg = "!!! "+document.title;
var timeoutId;
var blink = function() { document.title = document.title == msg ? ' ' : msg; };
var clear = function() {
clearInterval(timeoutId);
document.title = oldTitle;
window.onmousemove = null;
timeoutId = null;
inst.isBlinking = false;
};
return function () {
if (!timeoutId) {
timeoutId = setInterval(blink, 1000);
window.onmousemove = clear;
}
};
}());
newExcitingAlerts();
this.isBlinking = true;
};
};
this.playNewMessageSound = function() {
if (Modernizr.audio && this.audio !== null) {
this.audio.src = Modernizr.audio.ogg ? WWW_DIR_JAVASCRIPT_FILES + '/new_message.ogg?v=3' :
Modernizr.audio.mp3 ? WWW_DIR_JAVASCRIPT_FILES + '/new_message.mp3?v=3' : WWW_DIR_JAVASCRIPT_FILES + '/new_message.wav?v=3';
this.audio.load();
};
if(!$("textarea[name=ChatMessage]").is(":focus")) {
this.startBlinking();
};
};
this.playInvitationSound = function() {
if (Modernizr.audio && this.audio !== null) {
this.audio.src = Modernizr.audio.ogg ? WWW_DIR_JAVASCRIPT_FILES + '/invitation.ogg' :
Modernizr.audio.mp3 ? WWW_DIR_JAVASCRIPT_FILES + '/invitation.mp3' : WWW_DIR_JAVASCRIPT_FILES + '/invitation.wav';
this.audio.load();
}
};
this.playPreloadSound = function() {
if (Modernizr.audio && this.audio !== null) {
this.audio.src = Modernizr.audio.ogg ? WWW_DIR_JAVASCRIPT_FILES + '/silence.ogg' :
Modernizr.audio.mp3 ? WWW_DIR_JAVASCRIPT_FILES + '/silence.mp3' : WWW_DIR_JAVASCRIPT_FILES + '/silence.wav';
this.audio.load();
}
};
this.scrollLoading = false;
this.scrollPending = false;
this.loadPreviousMessages = function (inst, noScroll) {
if (this.scrollLoading == false) {
this.scrollLoading = true;
var _that = this;
inst.find('.material-icons').addClass('lhc-spin');
$.getJSON(this.wwwDir + 'chat/loadpreviousmessages/' + inst.attr('chat-id') + '/' + inst.attr('message-id') + '/(initial)/' + inst.attr('data-initial') + '/(original)/' + inst.attr('chat-original-id'), function(data) {
if (data.error == false) {
inst.find('.material-icons').removeClass('lhc-spin');
inst.attr('data-initial',0);
var msg = $('#messagesBlock-'+inst.attr('chat-original-id'));
var scrollHeight = msg[0].scrollHeight;
var currentScroll = msg.scrollTop();
msg.prepend(data.result);
lhinst.addQuateHandler(inst.attr('chat-original-id'));
var newScrollHeight = msg[0].scrollHeight;
var scrollDiff = newScrollHeight - scrollHeight;
if (inst.attr('auto-scroll') == 1) {
inst.attr('auto-scroll',0);
msg.scrollTop(msg.prop('scrollHeight'));
} else if (!noScroll) {
var elm = document.getElementById('scroll-to-chat-' + inst.attr('chat-id') + '-' + inst.attr('message-id'));
if (elm) {
msg[0].scrollTop = elm.offsetTop;
}
} else {
msg.scrollTop(currentScroll + scrollDiff);
}
if (data.has_messages == true) {
inst.attr('message-id', data.message_id);
inst.attr('chat-id',data.chat_id);
_that.scrollLoading = false;
if (_that.scrollPending == true) {
_that.scrollPending = false;
_that.loadPreviousMessages(inst, noScroll);
}
} else {
inst.remove();
_that.scrollLoading = false;
_that.scrollPending = false;
}
} else {
_that.scrollLoading = false;
_that.scrollPending = false;
}
});
} else {
this.scrollPending = true;
}
};
this.hidenicknamesstatus = null;
this.onScrollAdmin = function(chat_id)
{
var messageBlock = $('#messagesBlock-'+chat_id);
var scrollHeight = messageBlock.prop("scrollHeight");
var isAtTheBottom = Math.abs((scrollHeight - messageBlock.prop("scrollTop")) - messageBlock.prop("clientHeight"));
if (isAtTheBottom > 20) {
$('#scroll-button-admin-'+chat_id).removeClass('d-none');
} else {
$('#scroll-button-admin-'+chat_id).addClass('d-none').find('> button').text($('#scroll-button-admin-'+chat_id+' > button').attr('data-default'));
}
}
this.scrollToTheBottomMessage = function(chat_id)
{
var unreadSeparator = $('#unread-separator-'+chat_id);
if (unreadSeparator.length > 0) {
unreadSeparator[0].scrollIntoView();
setTimeout(function(){
unreadSeparator.remove();
},1000);
} else {
var messagesBlock = $('#messagesBlock-'+chat_id);
messagesBlock.scrollTop(messagesBlock.prop('scrollHeight'));
}
}
this.syncadmincall = function()
{
if (this.chatsSynchronising.length > 0)
{
if (this.underMessageAdd == false && this.syncroRequestSend == false)
{
this.syncroRequestSend = true;
var activeChatPane = $('#tabs > div.tab-content > div.chat-tab-pane.active');
var activeChatId = activeChatPane.length > 0 ? activeChatPane.attr('id').replace('chat-id-', '') : 0;
$.postJSON(this.wwwDir + this.syncadmin ,{ 'chats[]': this.chatsSynchronisingMsg, 'active_chat_id': activeChatId }, function(data){
if (typeof data.error_url !== 'undefined') {
document.location.replace(data.error_url);
}
try {
if (data.error == 'false')
{
if (data.result != 'false')
{
var playSound = false
$.each(data.result,function(i,item) {
var messageBlock = $('#messagesBlock-'+item.chat_id);
var scrollHeight = messageBlock.prop("scrollHeight");
var isAtTheBottom = Math.abs((scrollHeight - messageBlock.prop("scrollTop")) - messageBlock.prop("clientHeight"));
messageBlock.find('.pending-storage').slice(0, item.mn).remove();
var mainElement = $('#chat-tab-link-'+item.chat_id);
var needUnreadSeparator = !focused;
if (!mainElement.hasClass('active')) {
if (mainElement.find('span.msg-nm').length > 0) {
var totalMsg = (parseInt(mainElement.find('span.msg-nm').attr('rel')) + item.mn);
mainElement.find('span.msg-nm').html(' (' + totalMsg + ')' ).attr('rel',totalMsg);
} else {
needUnreadSeparator = true;
mainElement.append('<span rel="'+item.mn+'" class="msg-nm"> ('+item.mn+')</span>');
mainElement.addClass('has-pm');
}
}
if (isAtTheBottom > 20) {
needUnreadSeparator = true;
$('#scroll-button-admin-'+item.chat_id+' > button').text($('#scroll-button-admin-'+item.chat_id+' > button').attr('data-new'));
}
if (needUnreadSeparator == true && document.getElementById('unread-separator-'+item.chat_id) === null) {
item.content = item.content.replace('<span class="usr-tit','<div id="unread-separator-'+item.chat_id+'" class="new-msg-holder border-bottom border-danger text-center"><span class="new-msg bg-danger text-white d-inline-block fs12 rounded-top">'+confLH.transLation.new+'</span></div><span class="usr-tit');
}
messageBlock.append(item.content);
messageBlock.find('.pending-storage').appendTo(messageBlock);
lhinst.addQuateHandler(item.chat_id);
if (item.msfrom > 0) {
if ($('#msg-'+item.msfrom).attr('data-op-id') != item.msop) {
$('#msg-'+item.msfrom).next().addClass('operator-changes');
}
}
if (isAtTheBottom < 20) {
messageBlock.scrollTop(scrollHeight);
}
lhinst.updateChatLastMessageID(item.chat_id,item.message_id);
if (playSound == false && data.uw == 'false' && (typeof item.ignore === 'undefined' || typeof item.ignore === false))
{
playSound = true;
}
if (data.uw == 'false') {
ee.emitEvent('angularActionHappened',[{'type':'user_wrote','chat_id': item.chat_id, 'msg' : item.msg, 'nick': item.nck}]);
}
if ( confLH.new_message_browser_notification == 1 && data.uw == 'false' && (typeof item.ignore === 'undefined' || typeof item.ignore === false)) {
lhinst.showNewMessageNotification(item.chat_id,item.msg,item.nck);
};
ee.emitEvent('eventSyncAdmin', [item,i]);
});
if ( confLH.new_message_sound_admin_enabled == 1  && data.uw == 'false' && playSound == true) {
lhinst.playNewMessageSound();
};
};
if (data.result_status != 'false')
{
var groupTabs = $('#group-chats-status').hasClass('chat-active');
$.each(data.result_status,function(i,item) {
var typingIndicator = $('#user-is-typing-'+item.chat_id);
if (item.tp == 'true') {
if (lhinst.nodeJsMode == false) {
typingIndicator.html(item.tx);
}
if (typingIndicator.css('visibility') == 'hidden') {
typingIndicator.css('visibility','visible');
}
} else {
if (lhinst.nodeJsMode == false) {
typingIndicator.css('visibility','hidden');
}
};
$('#last-msg-chat-'+item.chat_id).text(item.lmsg);
var userChatStatus = $('#user-chat-status-'+item.chat_id);
var wasOnline = userChatStatus.hasClass('icon-user-online');
$('#chat-duration-'+item.chat_id).text(item.cdur);
userChatStatus.removeClass('icon-user-online icon-user-away icon-user-pageview');
$('#msg-send-status-'+item.chat_id).removeClass('icon-user-online icon-user-offline');
if (item.us == 0) {
userChatStatus.addClass('icon-user-online');
} else if (item.us == 2) {
userChatStatus.addClass('icon-user-away');
} else if (item.us == 3) {
userChatStatus.addClass('icon-user-pageview');
}
if (groupTabs == true) {
if (wasOnline == true && item.us != 0 || (lhinst.hidenicknamesstatus != groupTabs && item.us != 0)) {
$('#ntab-chat-' + item.chat_id).hide();
} else if (wasOnline == false && item.us == 0 || (lhinst.hidenicknamesstatus != groupTabs && item.us == 0)) {
$('#ntab-chat-' + item.chat_id).show();
}
} else if (lhinst.hidenicknamesstatus != groupTabs) {
$('#ntab-chat-' + item.chat_id).show();
}
var statusel = $('#chat-id-'+item.chat_id +'-mds');
if (statusel.attr('data-chat-status') != item.cs || statusel.attr('data-chat-user') != item.co)
{
lhinst.updateVoteStatus(item.chat_id);
}
if (item.um == 1) {
statusel.addClass('chat-unread');
$('#msg-send-status-'+item.chat_id).addClass('icon-user-offline');
if (item.ssub == 3) {
$('#messagesBlock-'+item.chat_id).find('.msg-del-st-0,.msg-del-st-1').removeClass('msg-del-st-0 msg-del-st-1').addClass('msg-del-st-2').text('done_all');
}
} else {
$('#msg-send-status-'+item.chat_id).addClass('icon-user-online');
statusel.removeClass('chat-unread');
$('#messagesBlock-'+item.chat_id).find('.msg-del-st-0,.msg-del-st-1,.msg-del-st-2').remove();
}
if (item.lp !== false) {
statusel.attr('title',item.lp+' s.');
} else {
statusel.attr('title','');
}
if (typeof item.oad != 'undefined' && item.oad == 1) {
$('#lhc_sync_operation').remove();
var th = document.getElementsByTagName('head')[0];
var s = document.createElement('script');
s.setAttribute('id','lhc_sync_operation');
s.setAttribute('type','text/javascript');
s.setAttribute('src',WWW_DIR_JAVASCRIPT + 'chat/loadoperatorjs/(type)/chat/(id)/'+item.chat_id);
th.appendChild(s);
};
});
};
if (data.cg) {
$.each(data.cg,function(i,item) {
return lhinst.removeDialogTab(item,$('#tabs'),true);
});
}
lhinst.hidenicknamesstatus = groupTabs;
clearTimeout(lhinst.userTimeout);
lhinst.userTimeout = setTimeout(chatsyncadmin,confLH.chat_message_sinterval);
ee.emitEvent('chatAdminSync', [data]);
};
} catch (err) {
clearTimeout(lhinst.userTimeout);
lhinst.userTimeout = setTimeout(chatsyncadmin,confLH.chat_message_sinterval);
};
lhinst.setSynchronizationRequestSend(false);
if (LHCCallbacks.syncadmincall) {
LHCCallbacks.syncadmincall(lhinst,data);
};
}).fail(function(){
clearTimeout(lhinst.userTimeout);
lhinst.userTimeout = setTimeout(chatsyncadmin,confLH.chat_message_sinterval);
lhinst.setSynchronizationRequestSend(false);
});
} else {
clearTimeout(lhinst.userTimeout);
lhinst.userTimeout = setTimeout(chatsyncadmin,confLH.chat_message_sinterval);
}
} else {
this.isSinchronizing = false;
}
};
this.updateVoteStatus = function(chat_id, internal) {
var that = this;
$.getJSON(this.wwwDir + 'chat/updatechatstatus/'+chat_id ,{ }, function(data){
$('#main-user-info-tab-'+chat_id).html(data.result);
$('#messagesBlock-'+chat_id+' span.vis-tit').each(function(i) {
var cache = $(this).children();
$(this).text(' '+data.nick).prepend(cache);
});
$('#ntab-chat-'+chat_id).text(data.nick);
ee.emitEvent('chatTabInfoReload', [chat_id]);
!internal && that.channel && that.channel.postMessage({'action':'update_chat','args':{'chat_id' : parseInt(chat_id)}});
});
};
this.updateChatLastMessageID = function(chat_id,message_id)
{
this.chatsSynchronisingMsg[this.getChatIndex(chat_id)] = chat_id+','+message_id;
};
this.requestNotificationPermission = function() {
if (window.webkitNotifications) {
window.webkitNotifications.requestPermission();
} else if(window.Notification){
Notification.requestPermission(function(permission){});
} else {
alert('Notification API in your browser is not supported.');
}
};
this.playNewChatAudio = function(sound) {
clearTimeout(this.soundIsPlaying);
this.soundPlayedTimes++;
if (Modernizr.audio && this.audio !== null) {
this.audio.src = Modernizr.audio.ogg ? WWW_DIR_JAVASCRIPT_FILES + '/'+sound+'.ogg?v=4' :
Modernizr.audio.mp3 ? WWW_DIR_JAVASCRIPT_FILES + '/'+sound+'.mp3?v=4' : WWW_DIR_JAVASCRIPT_FILES + '/'+sound+'.wav?v=4';
this.audio.load();
if (confLH.repeat_sound > this.soundPlayedTimes) {
var inst = this;
this.soundIsPlaying = setTimeout(function(){inst.playNewChatAudio(sound);},confLH.repeat_sound_delay*1000);
}
};
};
this.focusChanged = function(status){
if (confLH.new_message_browser_notification == 1 && status == true){
if (window.webkitNotifications || window.Notification) {
var inst = this;
$.each(this.chatsSynchronising, function( index, chat_id ) {
if (typeof inst.notificationsArrayMessages[chat_id] !== 'undefined') {
if (window.webkitNotifications) {
inst.notificationsArrayMessages[chat_id].cancel();
} else {
inst.notificationsArrayMessages[chat_id].close();
}
delete inst.notificationsArrayMessages[chat_id];
}
});
}
}
if (parseInt(this.chat_id) > 0) {
this.scheduleSync();
}
};
this.notificationsArrayMessages = [];
this.showNewMessageNotification = function(chat_id,message,nick) {
try {
if (window.Notification && focused == false && window.Notification.permission == 'granted') {
if (typeof this.notificationsArrayMessages[chat_id] !== 'undefined') {
this.notificationsArrayMessages[chat_id].close();
delete this.notificationsArrayMessages[chat_id];
};
var notification = new Notification(nick, { icon: WWW_DIR_JAVASCRIPT_FILES_NOTIFICATION + '/notification.png', body: message });
var _that = this;
notification.onclick = function () {
window.focus();
notification.close();
delete _that.notificationsArrayMessages[chat_id];
};
notification.onclose = function() {
if (typeof _that.notificationsArrayMessages[chat_id] !== 'undefined') {
delete _that.notificationsArrayMessages[chat_id];
};
};
this.notificationsArrayMessages[chat_id] = notification;
this.scheduleNewMessageClose(notification,chat_id);
}
} catch(err) {
console.log(err);
};
};
this.scheduleNewMessageClose = function(notification, chat_id) {
var _that = this;
setTimeout(function() {
if (window.webkitNotifications) {
notification.cancel();
} else {
notification.close();
};
if (typeof _that.notificationsArrayMessages[chat_id] !== 'undefined') {
delete _that.notificationsArrayMessages[chat_id];
};
},10*1000);
};
this.playSoundNewAction = function(identifier,chat_id,nick,message,nt) {
if (this.backgroundChats.indexOf(parseInt(chat_id)) != -1) {
return ;
}
ee.emitEvent('angularActionHappened',[{'type': identifier, 'chat_id': chat_id, 'msg' : message, 'nick': nick}]);
if (confLH.new_chat_sound_enabled == 1 && (confLH.sn_off == 1 || $('#online-offline-user').text() == 'flash_on') && (identifier == 'active_chats' || identifier == 'bot_chats' || identifier == 'pmails' || identifier == 'amails' || identifier == 'transferred_mail' || identifier == 'pending_chat' || identifier == 'transfer_chat' || identifier == 'unread_chat' || identifier == 'pending_transfered')) {
this.soundPlayedTimes = 0;
this.playNewChatAudio(identifier == 'active_chats' ? 'alert' : 'new_chat');
};
if(!$("textarea[name=ChatMessage]").is(":focus") && (confLH.sn_off == 1 || $('#online-offline-user').text() == 'flash_on') && (identifier == 'subject_chats' || identifier == 'active_chats' || identifier == 'bot_chats' || identifier == 'pending_chat' || identifier == 'transfer_chat' || identifier == 'unread_chat' || identifier == 'pending_transfered')) {
this.startBlinking();
};
if (identifier == 'subject_chats') {
this.soundPlayedTimes = 0;
this.playNewChatAudio('subject_chat');
}
var inst = this;
if ( (identifier == 'subject_chats' || identifier == 'active_chats' || identifier == 'pmails' || identifier == 'amails' || identifier == 'transferred_mail' || identifier == 'pending_chat' || identifier == 'transfer_chat' || identifier == 'unread_chat' || identifier == 'bot_chats' || identifier == 'pending_transfered') && (confLH.sn_off == 1 || $('#online-offline-user').text() == 'flash_on') && window.Notification && window.Notification.permission == 'granted') {
var notification = new Notification(nick, { icon: WWW_DIR_JAVASCRIPT_FILES_NOTIFICATION + '/notification.png', body: message, requireInteraction : true });
notification.onclick = function () {
if (identifier == 'subject_chats' || identifier == 'active_chats' || identifier == 'pending_chat' || identifier == 'unread_chat' || identifier == 'pending_transfered' || identifier == 'bot_chats') {
if ($('#tabs').length > 0) {
window.focus();
inst.addOpenTrace('click_notification');
inst.startChat(chat_id, $('#tabs'), nt);
} else {
inst.startChatNewWindow(chat_id,'ChatRequest');
}
} else if (identifier == 'pmails' || identifier == 'amails') {
if ($('#tabs').length > 0) {
window.focus();
inst.startMailChat(chat_id, $('#tabs'), nt);
} else {
inst.startMailNewWindow(chat_id,'ChatMail');
}
} else if (identifier == 'transferred_mail') {
inst.startChatNewWindowTransferByTransfer(chat_id, nt, 1);
} else {
inst.startChatNewWindowTransferByTransfer(chat_id, nt, 0);
};
notification.close();
};
if (identifier != 'pending_transfered') {
if (identifier == 'pmails' || identifier == 'amails' || identifier == 'transferred_mail')
{
if (this.notificationsArrayMail[chat_id] !== 'undefined') {
notification.close();
}
this.notificationsArrayMail[chat_id] = notification;
} else {
if (this.notificationsArray[chat_id] !== 'undefined') {
notification.close();
}
this.notificationsArray[chat_id] = notification;
}
};
};
if (identifier == 'transfer_chat' && confLH.accept_chats) {
inst.startChatNewWindowTransferByTransfer(chat_id, nt, 0, true);
} else if (identifier == 'transfer_chat' && confLH.show_alert_transfer == 1) {
if (confirm(confLH.transLation.transfered + "\n\n" + message)) {
inst.startChatNewWindowTransferByTransfer(chat_id, nt, 0);
}
}
if (identifier == 'transferred_mail' && confLH.show_alert_transfer == 1) {
if (confirm(confLH.transLation.transfered + "\n\n" + message)) {
inst.startChatNewWindowTransferByTransfer(chat_id, nt, 1);
}
}
if (confLH.show_alert == 1) {
if (confirm(confLH.transLation.new_chat+"\n\n"+message)) {
if (identifier == 'pending_chat' || identifier == 'unread_chat' || identifier == 'pending_transfered' || identifier == 'bot_chats') {
if ($('#tabs').length > 0) {
window.focus();
inst.addOpenTrace('alert_open');
inst.startChat(chat_id, $('#tabs'), nt);
} else {
inst.startChatNewWindow(chat_id,'ChatRequest');
}
} else if (identifier == 'pmails' || identifier == 'amails') {
if ($('#tabs').length > 0) {
window.focus();
inst.startMailChat(chat_id, $('#tabs'), nt);
} else {
inst.startMailNewWindow(chat_id,'ChatMail');
}
} else if (identifier == 'transferred_mail') {
inst.startChatNewWindowTransferByTransfer(chat_id, nt, 1);
} else {
inst.startChatNewWindowTransferByTransfer(chat_id, nt, 0);
};
};
};
};
this.syncadmininterfacestatic = function()
{
try {
ee.emitEvent('angularLoadChatList');
} catch(err) {
};
};
this.addingUserMessage = false;
this.addUserMessageQueue = [];
this.addDelayedTimeout = null;
this.addmsgadmin = function (chat_id, message)
{
$('#unread-separator-'+chat_id).remove();
var textArea = $("#CSChatMessage-"+chat_id);
if (textArea.is("[readonly]")) {
return;
}
var pdata = {
msg	: message || (textArea.prop('nodeName') == 'LHC-EDITOR' ? textArea[0].getContent() : textArea.val())
};
if (textArea.attr('meta-msg')) {
pdata.meta_msg = textArea.attr('meta-msg');
textArea.removeAttr('meta-msg');
}
if (textArea.attr('mode-write')) {
pdata.mode_write = textArea.attr('mode-write');
}
if (pdata.msg == '') {
return;
}
if (this.speechHandler !== false) {
this.speechHandler.messageSend();
};
message || (textArea.prop('nodeName') == 'LHC-EDITOR' ? textArea[0].setContent('',{'ignore_meta':true}) : textArea.val(''));
var placeholerOriginal = textArea.attr('placeholder');
textArea.attr('placeholder',confLH.transLation.sending || 'Sending...');
if (textArea.hasClass('edit-mode')) {
pdata.msgid = textArea.attr('data-msgid');
$.postJSON(this.wwwDir + 'chat/updatemsg/' + chat_id, pdata , function(data){
textArea.attr('placeholder',placeholerOriginal);
textArea.removeClass('edit-mode');
textArea.removeAttr('data-msgid');
if (data.error == 'f') {
$('#msg-'+pdata.msgid).replaceWith(data.msg);
if (LHCCallbacks.addmsgadmin) {
LHCCallbacks.addmsgadmin(chat_id);
};
ee.emitEvent('chatAddMsgAdmin', [chat_id]);
lhinst.addQuateHandler(chat_id);
return true;
} else {
alert(data.result);
}
});
} else {
var inst = this;
var messagesBlock = $('#messagesBlock-'+chat_id);
message || messagesBlock.append("<div class=\"message-row message-admin pending-storage\"><div class=\"msg-body\"><span class=\"material-icons lhc-spin\">autorenew</span>" + $("<div>").text(pdata.msg).html() + "</div></div>");
messagesBlock.scrollTop(messagesBlock.prop('scrollHeight'));
if (this.addingUserMessage == false)
{
this.addingUserMessage = true;
var hasSubjects = false;
if (textArea.attr('subjects_ids')) {
pdata.subjects_ids = textArea.attr('subjects_ids');
textArea.removeAttr('subjects_ids');
hasSubjects = true;
}
if (textArea.attr('canned_id')) {
pdata.canned_id = textArea.attr('canned_id');
textArea.removeAttr('canned_id');
}
if (textArea.attr('whisper')) {
pdata.whisper = 1;
}
$.postJSON(this.wwwDir + this.addmsgurl + chat_id, pdata , function(data) {
textArea.removeAttr('readonly').attr('placeholder',placeholerOriginal);
if (data.error == 'false') {
$('#messagesBlock-' + chat_id + ' .temporal-msg').remove();
if (LHCCallbacks.addmsgadmin) {
LHCCallbacks.addmsgadmin(chat_id);
};
ee.emitEvent('chatAddMsgAdmin', [chat_id]);
if (data.r != '') {
$('#messagesBlock-'+chat_id).append(data.r).scrollTop($("#messagesBlock-"+chat_id).prop("scrollHeight")).find('.pending-storage').remove();
};
if (data.hold_removed === true) {
$('#hold-action-'+chat_id).removeClass('btn-outline-info');
} else if (data.hold_added === true) {
$('#hold-action-'+chat_id).addClass('btn-outline-info');
}
if (hasSubjects == true || data.update_status === true) {
inst.updateVoteStatus(chat_id);
}
lhinst.syncadmincall();
} else {
if (typeof data.token !== 'undefined') {
confLH.csrf_token = data.token;
}
textArea.attr('placeholder',placeholerOriginal);
if (textArea.prop('nodeName') == 'LHC-EDITOR') {
textArea[0].setContent(pdata.msg,{"convert_bbcode" : true});
} else {
textArea.val((textArea.val() + ' ' + pdata.msg).trim());
}
$('.pending-storage').first().remove();
$('#messagesBlock-' + chat_id + ' .temporal-msg').remove();
var escaped = '<div style="margin:10px 0px 30px 0px;" class="alert alert-warning' + (data.temporal ? ' temporal-msg' : '') + '" role="alert">' + (data.safe ? data.r : $("<div>").text(data.r).html()) + '</div>';
$('#messagesBlock-'+chat_id).append(escaped).scrollTop($("#messagesBlock-"+chat_id).prop("scrollHeight"));
}
inst.addingUserMessage = false;
if (inst.addUserMessageQueue.length > 0) {
var elementAdd = inst.addUserMessageQueue.shift()
inst.addmsgadmin(elementAdd.chat_id,elementAdd.msg);
}
return true;
}).fail(function(respose) {
textArea.attr('placeholder',placeholerOriginal);
if (textArea.prop('nodeName') == 'LHC-EDITOR') {
textArea[0].insertContent(pdata.msg,{"convert_bbcode" : true});
} else {
textArea.val(textArea.val() + ' ' + pdata.msg);
}
var escaped = '<div style="margin:10px 10px 30px 10px;" class="alert alert-warning" role="alert">' + $("<div>").text('You have weak internet connection or the server has problems. Try to refresh the page or send the message again.' + (typeof respose.status !== 'undefined' ? ' Error code ['+respose.status+']' : '') + (typeof respose.responseText !== 'undefined' ? respose.responseText : '')).html() + '</div>';
$('#messagesBlock-'+chat_id).append(escaped).scrollTop($("#messagesBlock-"+chat_id).prop("scrollHeight"));
$('.pending-storage').first().remove();
inst.addingUserMessage = false;
if (inst.addUserMessageQueue.length > 0) {
var elementAdd = inst.addUserMessageQueue.shift()
inst.addmsgadmin(elementAdd.chat_id,elementAdd.msg);
}
});
} else {
textArea.attr('placeholder', placeholerOriginal);
this.addUserMessageQueue.push({'chat_id':chat_id,'msg':pdata.msg});
}
}
};
this.editPrevious = function(chat_id) {
var textArea = $('#CSChatMessage-'+chat_id);
let presentValue = "";
if (textArea.prop('nodeName') == 'LHC-EDITOR') {
presentValue = textArea[0].getContent();
} else {
presentValue = textArea.val();
}
if (presentValue == '' && textArea.attr('disable-edit') !== "true") {
$.getJSON(this.wwwDir + 'chat/editprevious/'+chat_id, function(data){
if (data.error == 'f') {
if (textArea.prop('nodeName') == 'LHC-EDITOR') {
textArea[0].setContent(data.msg,{"convert_bbcode" : true});
} else {
textArea.val(data.msg);
}
textArea.attr('data-msgid',data.id);
textArea.addClass('edit-mode');
$('#msg-'+data.id).addClass('edit-mode');
if (LHCCallbacks.editPrevious) {
LHCCallbacks.editPrevious(chat_id, data);
}
}
});
}
};
this.afterAdminChatInit = function (chat_id) {
if (LHCCallbacks.afterAdminChatInit) {
LHCCallbacks.afterAdminChatInit(chat_id);
}
};
this.getInputSelection = function(elem) {
if (typeof elem != "undefined") {
s = elem[0].selectionStart;
e = elem[0].selectionEnd;
return elem.val().substring(s, e);
} else {
return '';
}
}
this.handleBBCode = function(inst) {
var elem = $(inst.attr('data-selector'));
var bbcodeend = typeof inst.attr("data-bbcode-end") !== 'undefined' ?  inst.attr("data-bbcode-end") : inst.attr("data-bbcode");
if (elem.prop('nodeName') == 'LHC-EDITOR') {
elem[0].insertFormating(inst.attr("data-bbcode"),bbcodeend);
} else {
var str = elem.val();
if (typeof elem != "undefined") {
var s = elem[0].selectionStart, e = elem[0].selectionEnd;
var selection = str.substring(s, e);
} else {
var selection = '';
}
if (selection.length > 0) {
$(inst.attr('data-selector')).val(str.substr(0,s) + "[" + inst.attr("data-bbcode") + "]" + selection + "[/" + bbcodeend + "]" + str.substring(e));
} else {
$(inst.attr('data-selector')).val(str + "[" + inst.attr("data-bbcode") + "]" + "[/" + bbcodeend + "]");
}
}
return false;
}
this.addAdminChatFinished = function(chat_id, last_message_id, arg) {
var _that = this;
var $textarea = jQuery('#CSChatMessage-'+chat_id);
if ($textarea.prop('nodeName') != 'LHC-EDITOR') {
var cannedMessageSuggest = new LHCCannedMessageAutoSuggest({
'chat_id': chat_id,
'uppercase_enabled': confLH.auto_uppercase
});
}
var colorPickerDom = document.getElementById('color-picker-chat-' + chat_id);
if (colorPickerDom !== null) {
var colorP = new ColorPicker({
dom: document.getElementById('color-picker-chat-' + chat_id),
value: '#0F0'
});
colorP.addEventListener('change', function (colorItem) {
$('#color-apply-'+chat_id).attr('data-bbcode','color='+colorP.getValue('hex'));
});
$('.downdown-menu-color-'+chat_id).on('click', function (e) {
if ($(this).parent().is(".show")) {
var target = $(e.target);
if (target.hasClass("keepopen") || target.parents(".keepopen").length){
return false;
} else {
return true;
}
}
});
$('.downdown-menu-color-'+chat_id+' .color-item').on('click',function () {
colorP.setValue($(this).attr('data-color'));
});
}
$textarea.bind('click', function (evt) {
$('.dropdown-menu-main').removeClass('show').find('> .dropdown-menu').removeClass('show');
if ($textarea.prop('nodeName') != 'LHC-EDITOR') {
$('#CSChatMessage-'+chat_id).focus();
}
if (!$('#chat-tab-link-'+chat_id).hasClass('active')) {
$('#chat-tab-link-'+chat_id).click();
(new bootstrap.Tab(document.querySelector('#chat-tab-link-'+chat_id))).show();
}
});
$('#dropdown-menu-main-action-'+chat_id).click(function(){
$(this).parent().toggleClass('show');
$(this).parent().find('> div.dropdown-menu').toggleClass('show');
});
if ($textarea.prop('nodeName') != 'LHC-EDITOR') {
$textarea.bind('keydown', 'return', function (evt) {
_that.addmsgadmin(chat_id);
ee.emitEvent('afterAdminMessageSent',[chat_id]);
$textarea[0].rows = $textarea.attr('data-rows-default');
return false;
});
$textarea.bind('focus', function (evt) {
ee.emitEvent('chatAreaFocused',[chat_id]);
});
$textarea.bind('keyup', 'up', function (evt){
_that.editPrevious(chat_id);
});
$textarea.bind('keyup', function (evt){
if ($textarea.val() == '') {
$textarea.removeAttr('subjects_ids');
$textarea.removeAttr('canned_id');
$textarea.removeAttr('content_modified');
}
if ($textarea.val() == '' && evt.altKey && (evt.which == 38 || evt.which == 40)) {
ee.emitEvent('activateNextTab',[chat_id,(evt.which == 38 ? true : false)]);
return ;
}
var ta = $textarea[0];
if ((evt.which == 38 || evt.which == 8 || evt.which == 46) && ta.value.split(/\r\n|\r|\n/).length <= ta.rows && parseInt($textarea.attr('data-rows-default')) <= ta.value.split(/\r\n|\r|\n/).length) {
ta.rows = ta.value.split(/\r\n|\r|\n/).length;
}
var maxrows = 30;
var lh = ta.clientHeight / ta.rows;
while (ta.scrollHeight > ta.clientHeight && !window.opera && ta.rows < maxrows) {
ta.style.overflow = 'hidden';
ta.rows += 1;
$('#messagesBlock-'+chat_id).prop('scrollTop',$('#messagesBlock-'+chat_id).prop('scrollHeight'));
}
if (ta.scrollHeight > ta.clientHeight) ta.style.overflow = 'auto';
if ($textarea.val() != '') {
$textarea.attr('content_modified',true);
}
});
}
$messageBlock = $('#messagesBlock-'+chat_id);
$messageBlock.css('height',this.getLocalValue('lhc_mheight',confLH.defaultm_hegiht));
$messageBlock.data('resized',false);
$messageBlock.data('y', $messageBlock.outerHeight());
$messageBlock.bind('mouseup mousemove',function(event) {
var $this = jQuery(this);
if ($this.outerHeight() != $this.data('y')) {
if ($this.data('resized') == false) {
$this.css('height','1px');
$this.data('resized',true)
}
if (this.resize_timeout) {
clearTimeout(this.resize_timeout);
}
this.resize_timeout = setTimeout(function(){
_that.setLocalValue('lhc_mheight', $this.outerHeight());
$this.data('y', $this.outerHeight());
},100);
}
});
if (confLH.scroll_load == 1) {
$messageBlock[0].oldScrollTop = $messageBlock[0].scrollTop;
$messageBlock.bind('scroll',function(event) {
if (_that.scrollLoading == true) {
return ;
}
var $this = jQuery(this);
if ($this[0].oldScrollTop > $this[0].scrollTop && $this[0].scrollTop < 300 && $('#load-prev-btn-'+chat_id).length == 1) {
_that.loadPreviousMessages($('#load-prev-btn-'+chat_id), true);
}
$this[0].oldScrollTop = $this[0].scrollTop;
});
}
this.initTypingMonitoringAdmin(chat_id);
this.afterAdminChatInit(chat_id);
this.addSynchroChat(chat_id,last_message_id);
confLH.no_scroll_bottom !== 1 && $messageBlock.prop('scrollTop',$messageBlock.prop('scrollHeight'));
this.startSyncAdmin();
if (arg === null || typeof arg !== 'object' || arg.indexOf('background') === -1) {
this.hideNotification(chat_id);
} else {
$('#chat-tab-link-'+chat_id).click(function() {
_that.removeBackgroundChat(parseInt(chat_id));
_that.hideNotification(parseInt(chat_id));
});
}
try {
if (localStorage) {
if (localStorage.getItem('lhc_rch') == 1) {
this.processCollapse(chat_id);
}
}
} catch(e) {};
$('#chat-tab-items-' + chat_id+' > li > a').click(function(){
ee.emitEvent('adminChatTabSubtabClicked', [chat_id,$(this)]);
});
$('#chat-write-button-'+chat_id).click(function() {
$('#CSChatMessage-'+chat_id).show().focus().removeAttr("whisper").removeClass('bg-light').attr('placeholder',$(this).attr('data-plc'));
$(this).removeClass('btn-outline-secondary').addClass('btn-outline-primary');
$('#chat-preview-button-'+chat_id+',#chat-whisper-button-'+chat_id).removeClass('btn-outline-primary').addClass('btn-outline-secondary');
$('#chat-preview-container-'+chat_id).hide();
$('#chat-join-as-container-'+chat_id).removeClass('hide');
});
$('#chat-preview-button-'+chat_id).click(function() {
$('#chat-preview-container-'+chat_id).html('...').show();
$('#CSChatMessage-'+chat_id).hide();
$(this).removeClass('btn-outline-secondary').addClass('btn-outline-primary');
$('#chat-join-as-container-'+chat_id).addClass('hide');
$('#chat-write-button-'+chat_id+',#chat-whisper-button-'+chat_id).removeClass('btn-outline-primary').addClass('btn-outline-secondary');
jQuery.post(WWW_DIR_JAVASCRIPT +'chat/previewmessage', {msg_body: true, 'msg' : _that.getMessageContent(chat_id)}, function(data){
$('#chat-preview-container-'+chat_id).html(data);
});
});
$('#chat-whisper-button-'+chat_id).click(function() {
$('#CSChatMessage-'+chat_id).show().focus().attr('whisper','1').addClass('bg-light').attr('placeholder',$(this).attr('data-plc'));
$('#chat-preview-container-'+chat_id).hide();
$(this).removeClass('btn-outline-secondary').addClass('btn-outline-primary');
$('#chat-write-button-'+chat_id+',#chat-preview-button-'+chat_id).removeClass('btn-outline-primary').addClass('btn-outline-secondary');
$('#chat-join-as-container-'+chat_id).addClass('hide');
});
$('#chat-join-as-'+chat_id).click(function(){
$('#chat-join-as-container-'+chat_id).addClass('hide mode-chosen');
$('chat-write-button-'+chat_id).attr('data-plc',$('#chat-mode-selected-'+chat_id).find(":selected").attr('data-plc'));
$('#CSChatMessage-'+chat_id).attr('placeholder',$('#chat-mode-selected-'+chat_id).find(":selected").attr('data-plc'));
$('#CSChatMessage-'+chat_id).attr('mode-write',$('#chat-mode-selected-'+chat_id).val()).focus();
});
$('#chat-impersonate-option-'+chat_id).click(function(){
$('#chat-write-button-'+chat_id).click();
$('#chat-join-as-container-'+chat_id).removeClass('hide mode-chosen');
});
ee.emitEvent('adminChatLoaded', [chat_id,last_message_id,arg]);
};
this.getMessageContent = function(chat_id){
let elm = document.getElementById('CSChatMessage-'+chat_id);
if (elm) {
if (elm.nodeName == 'LHC-EDITOR') {
return elm.getContent();
} else {
return elm.value;
}
}
}
this.setFocus = function(chat_id) {
let elm = document.getElementById('CSChatMessage-'+chat_id);
if (elm) {
if (elm.nodeName == 'LHC-EDITOR') {
return elm.setFocus && elm.setFocus();
} else {
return elm.focus();
}
}
}
this.removeBackgroundChat = function(chat_id) {
var index = this.backgroundChats.indexOf(parseInt(chat_id));
if (index !== -1) {
delete this.backgroundChats[index];
};
};
this.getLocalValue = function(variable,defaultValue) {
try {
if (localStorage) {
var value = localStorage.getItem(variable);
if (value !== null) {
return value;
} else {
return defaultValue;
}
}
} catch(e) {}
return defaultValue;
};
this.setLocalValue = function(key,val){
try {
if (localStorage) {
localStorage.setItem(key,val);
}
} catch(e) {}
};
this.hideNotification = function(chat_id, type)
{
chat_id = parseInt(chat_id);
if (typeof type === 'undefined' || type != 'mail') {
if (typeof this.notificationsArray[chat_id] !== 'undefined' && this.backgroundChats.indexOf(chat_id) == -1) {
this.notificationsArray[chat_id].close();
delete this.notificationsArray[chat_id];
};
} else {
if (typeof this.notificationsArrayMail[chat_id] !== 'undefined') {
this.notificationsArrayMail[chat_id].close();
delete this.notificationsArrayMail[chat_id];
};
}
clearTimeout(this.soundIsPlaying);
}
this.showMyPermissions = function(user_id) {
$.get(this.wwwDir + 'permission/getpermissionsummary/'+user_id, function(data){
$('#permissions-summary').html(data);
});
};
this.updateMessageRowAdmin = function(chat_id, msgid){
$.getJSON(this.wwwDir + 'chat/getmessageadmin/' + chat_id + '/' + msgid, function(data) {
if (data.error == 'f') {
var messagesBlock = $('#messagesBlock-' + chat_id);
var needScroll = (messagesBlock.prop('scrollTop') + messagesBlock.height() + 30) > messagesBlock.prop('scrollHeight');
$('#msg-'+msgid).replaceWith(data.msg);
lhinst.addQuateHandler(chat_id);
$('#msg-'+msgid).addClass('msg-updated');
setTimeout(function(){
$('#msg-'+msgid).removeClass('msg-updated');
},2000);
needScroll && messagesBlock.scrollTop(messagesBlock.prop('scrollHeight'));
}
});
};
this.startSyncAdmin = function()
{
if (this.isSinchronizing == false)
{
this.isSinchronizing = true;
this.syncadmincall();
}
};
this.disableChatSoundAdmin = function(inst)
{
if (inst.prop('tagName') != 'I') {
inst = inst.find('> i.material-icons');
}
if (inst.text() == 'volume_off'){
$.post(this.wwwDir + 'user/setsettingajax/chat_message/1');
confLH.new_message_sound_admin_enabled = 1;
inst.text('volume_up');
} else {
$.post(this.wwwDir + 'user/setsettingajax/chat_message/0');
confLH.new_message_sound_admin_enabled = 0;
inst.text('volume_off');
}
return false;
};
this.disableNewChatSoundAdmin = function(inst)
{
if (inst.prop('tagName') != 'I') {
inst = inst.find('> i.material-icons');
}
if (inst.text() == 'volume_off'){
$.post(this.wwwDir+  'user/setsettingajax/new_chat_sound/1');
confLH.new_chat_sound_enabled = 1;
inst.text('volume_up');
} else {
$.post(this.wwwDir+  'user/setsettingajax/new_chat_sound/0');
confLH.new_chat_sound_enabled = 0;
inst.text('volume_off');
}
return false;
};
this.changeUserSettings = function(attr,value){
$.post(this.wwwDir+  'user/setsettingajax/'+attr+'/'+value);
};
this.changeUserSettingsIndifferent = function(attr,value) {
$.post(this.wwwDir+  'user/setsettingajax/'+attr+'/'+encodeURIComponent(value == '' ? '__empty__' : value)+'/(indifferent)/true');
};
this.changeStatusAction = function(form,chat_id){
var inst = this;
$.postJSON(form.attr('action'),form.serialize(), function(data) {
if (data.error == 'false') {
$('#myModal').modal('hide');
inst.updateVoteStatus(chat_id);
if (data.is_owner === true) {
$('#CSChatMessage-'+chat_id).attr('placeholder','');
inst.setFocus(chat_id);
}
} else {
alert(data.result);
}
});
return false;
};
this.submitModalForm = function(form, idElement){
var inst = this;
$('#modal-in-progress').removeClass('hide');
$('.modal-submit-disable').addClass('disabled').attr('disabled',"disabled");
$.ajax({
url: form.attr("action"),
type: form.attr("method"),
data: new FormData(form[0]),
processData: false,
contentType: false,
success: function (data, status)
{
$('#modal-in-progress').addClass('hide');
$('.modal-submit-disable').removeClass('disabled').attr('disabled',"disabled");
var idElementDetermined = idElement ? '#'+idElement : '#myModal';
if (!idElement) {
var styleOriginal = $('#myModal > .modal-dialog')[0].style.cssText;
}
$(idElementDetermined).html(data);
if (!idElement && $('#myModal > .modal-dialog').length > 0) {
$('#myModal > .modal-dialog')[0].style.cssText = styleOriginal;
} else {
$(idElementDetermined).html('<div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-body">'+data+'</div></div></div>');
}
},
error: function (xhr, desc, err)
{
alert('An error has accoured! ' + xhr.responseText);
}
});
return false;
};
this.pendingMessagesToStore = [];
this.setSubject = function(inst, chat_id) {
$('#subject-message-'+chat_id).text('...');
$.postJSON(this.wwwDir + 'chat/subject/'+chat_id + '/(subject)/' + inst.val() + '/(status)/' + inst.is(':checked'),{'update': true}, function(data) {
lhinst.updateVoteStatus(chat_id);
$('#subject-message-'+chat_id).text(data.message);
});
}
this.deleteChatfile = function(file_id){
$.postJSON(this.wwwDir + 'file/deletechatfile/' + file_id, function(data){
if (data.error == 'false') {
$('#file-id-'+file_id).remove();
} else {
alert(data.result);
}
});
};
this.updateChatFiles = function(chat_id) {
$.postJSON(this.wwwDir + 'file/chatfileslist/' + chat_id, function(data){
$('#chat-files-list-'+chat_id).html(data.result);
});
};
this.updateOnlineFiles = function(online_user_id) {
$.postJSON(this.wwwDir + 'file/onlinefileslist/' + online_user_id, function(data){
$('#online-user-files-list-'+online_user_id).html(data.result);
});
};
this.updateOnlineFilesUser = function(online_user_vid) {
$.postJSON(this.wwwDir + 'file/useronlinefileslist/' + online_user_vid, function(data){
$('#user-online-files-list').html(data.result);
});
};
this.addFileUpload = function(data_config) {
$('#fileupload-'+data_config.chat_id).fileupload({
url: this.wwwDir + 'file/uploadfileadmin/'+data_config.chat_id,
dataType: 'json',
add: function(e, data) {
var uploadErrors = [];
var acceptFileTypes = data_config.ft_op;
if(!(acceptFileTypes.test(data.originalFiles[0]['type']) || acceptFileTypes.test(data.originalFiles[0]['name']))) {
uploadErrors.push(data_config.ft_msg);
};
if(data.originalFiles[0]['size'] > data_config.fs) {
uploadErrors.push(data_config.fs_msg);
};
if(uploadErrors.length > 0) {
alert(uploadErrors.join("\n"));
} else {
data.submit();
};
},
done: function(e,data) {
var response = data.response();
if (response != undefined && response.result != undefined && response.result.error == 'true' && response.result.error_msg != undefined) {
alert(response.result.error_msg);
} else {
lhinst.updateChatFiles(data_config.chat_id);
var txtArea = $('#CSChatMessage-'+data_config.chat_id);
if (txtArea.prop('nodeName') == 'LHC-EDITOR') {
txtArea[0].insertContent(response.result.msg,{"new_line" : true,"convert_bbcode" : true});
} else {
var txtValue = jQuery.trim(txtArea.val());
txtArea.val(txtValue + (txtValue != '' ? "\n" : "") + response.result.msg + "\n");
}
}
if (LHCCallbacks.addFileUpload) {
LHCCallbacks.addFileUpload(data_config.chat_id);
}
},
dropZone: $('#CSChatMessage-'+data_config.chat_id),
pasteZone: $('#CSChatMessage-'+data_config.chat_id).prop('nodeName') == 'LHC-EDITOR' ? $('#CSChatMessage-'+data_config.chat_id+' > .form-send-textarea') : $('#CSChatMessage-'+data_config.chat_id),
progressall: function (e, data) {
var progress = parseInt(data.loaded / data.total * 100, 10);
$('#user-is-typing-'+data_config.chat_id).css('visibility','visible');
$('#user-is-typing-'+data_config.chat_id).html(progress+'%');
}}).prop('disabled', !$.support.fileInput)
.parent().addClass($.support.fileInput ? undefined : 'disabled');
};
this.addExecutionCommand = function(online_user_id,operation) {
$.postJSON(this.wwwDir + 'chat/addonlineoperation/' + online_user_id,{'operation':operation}, function(data){
if (LHCCallbacks.addExecutionCommand) {
LHCCallbacks.addExecutionCommand(online_user_id);
};
});
if (operation == 'lhc_screenshot') {
$('#user-screenshot-container').html('').addClass('screenshot-pending');
var inst = this;
setTimeout(function(){
inst.updateScreenshotOnline(online_user_id);
},15000);
};
};
this.addRemoteCommand = function(chat_id,operation) {
$.postJSON(this.wwwDir + 'chat/addoperation/' + chat_id,{'operation':operation}, function(data){
if (LHCCallbacks.addRemoteCommand) {
LHCCallbacks.addRemoteCommand(chat_id);
};
if (data.error == 'true' && data.errors != null) {
alert(data.errors.join("\n"));
}
});
if (operation == 'lhc_screenshot') {
$('#user-screenshot-container').html('').addClass('screenshot-pending');
var inst = this;
setTimeout(function(){
inst.updateScreenshot(chat_id);
},5000);
};
};
this.addRemoteOnlineCommand = function(online_user_id,operation) {
$.postJSON(this.wwwDir + 'chat/addonlineoperationiframe/' + online_user_id,{'operation':operation}, function(data){
if (LHCCallbacks.addRemoteOnlineCommand) {
LHCCallbacks.addRemoteOnlineCommand(online_user_id);
};
});
};
this.updateScreenshot = function(chat_id) {
$('#user-screenshot-container').html('').addClass('screenshot-pending');
$.get(this.wwwDir + 'chat/checkscreenshot/' + chat_id,function(data){
$('#user-screenshot-container-'+chat_id).html(data);
$('#user-screenshot-container-'+chat_id).removeClass('screenshot-pending');
});
};
this.updateScreenshotOnline = function(online_id) {
$('#user-screenshot-container').html('').addClass('screenshot-pending');
$.get(this.wwwDir + 'chat/checkscreenshotonline/' + online_id,function(data){
$('#user-screenshot-container-'+online_id).html(data);
$('#user-screenshot-container-'+online_id).removeClass('screenshot-pending');
});
};
this.delayQueue = [];
this.delayed = false;
this.intervalPending = null;
this.gmaps_loading = false;
this.queue_render = [];
this.showMessageLocation = function(id,lat,lon) {
var myLatLng = {lat: lat, lng: lon};
if (this.gmaps_loaded == true) {
var map = new google.maps.Map(document.getElementById('msg-location-' + id), {
zoom: 13,
center: myLatLng
});
var marker = new google.maps.Marker({
position: myLatLng,
map: map,
title: lat+","+lon
});
} else {
if (this.gmaps_loading == false) {
this.gmaps_loading = true;
var po = document.createElement('script'); po.type = 'text/javascript';
po.async = true;
po.src = 'https://maps.googleapis.com/maps/api/js?key='+confLH.gmaps_api_key+"&callback=chatMapLoaded";
var s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(po, s);
lhinst.queue_render.push({'id':id,'lat':lat,'lon':lon});
} else {
lhinst.queue_render.push({'id':id,'lat':lat,'lon':lon});
}
}
}
this.startChatNewWindow = function(chat_id,name)
{
var popupWindow = window.open(this.wwwDir + 'chat/single/'+chat_id,'chatwindow-chat-id-'+chat_id,"menubar=1,resizable=1,width=800,height=650");
if (popupWindow !== null) {
popupWindow.focus();
var inst = this;
setTimeout(function(){
inst.syncadmininterfacestatic();
history.pushState({}, '', '#chatlist');
document.location.hash = '#chatlist';
},1000);
ee.emitEvent('chatStartOpenWindow', [chat_id]);
}
};
this.setCloseWindowOnEvent = function (value)
{
this.closeWindowOnChatCloseDelete = value;
};
this.zoomImage = function(e) {
if (!e.classList.contains('img-remote')) {
lhc.revealModal({'url':e.src + '?modal=true'})
} else {
lhc.revealModal({'url': WWW_DIR_JAVASCRIPT + 'file/downloadfile/0/0' + '?modal=external&src='+e.src})
}
}
}
function chatMapLoaded()
{
if (lhinst.queue_render.length > 0){
lhinst.gmaps_loaded = true;
var i = lhinst.queue_render.pop();
var myLatLng = {lat: i.lat, lng: i.lon};
var map = new google.maps.Map(document.getElementById('msg-location-' + i.id), {
zoom: 13,
center: myLatLng
});
var marker = new google.maps.Marker({
position: myLatLng,
map: map,
title: i.lat+","+i.lon
});
if (lhinst.queue_render.length > 0) {
chatMapLoaded();
}
}
}
var lhinst = new lh();
lhinst.playPreloadSound();
function preloadSound() {
lhinst.playPreloadSound();
jQuery(document).off("click", preloadSound);
jQuery(document).off("touchstart", preloadSound);
}
jQuery(document).on("click", preloadSound);
jQuery(document).on("touchstart", preloadSound);
jQuery(document).on("click", function(){
lhinst.hidePopover();
});
function gMapsCallback(){
lhinst.gmaps_loaded = true;
var $mapCanvas = $('#map_canvas');
var map = new google.maps.Map($mapCanvas[0], {
zoom: GeoLocationData.zoom,
center: new google.maps.LatLng(GeoLocationData.lat, GeoLocationData.lng),
mapTypeId: google.maps.MapTypeId.ROADMAP,
disableDefaultUI: true,
options: {
zoomControl: true,
scrollwheel: true,
streetViewControl: true
}
});
var locationSet = false;
var processing = false;
var pendingProcess = false;
var pendingProcessTimeout = false;
google.maps.event.addListener(map, 'idle', showMarkers);
var mapTabSection = $('#map-activator');
function showMarkers() {
if ( processing == false) {
if (mapTabSection.hasClass('active')) {
processing = true;
$.ajax({
url : WWW_DIR_JAVASCRIPT + 'chat/jsononlineusers'+(parseInt($('#id_department_map_id').val()) > 0 ? '/(department)/'+parseInt($('#id_department_map_id').val()) : '' )+(parseInt($('#svelte-maxrowsFilter').val()) > 0 ? '/(maxrows)/'+parseInt($('#svelte-maxrowsFilter').val()) : '' )+(parseInt($('#svelte-userTimeoutFilter').val()) > 0 ? '/(timeout)/'+parseInt($('#svelte-userTimeoutFilter').val()) : '' ),
dataType: "json",
error:function(){
clearTimeout(pendingProcessTimeout);
pendingProcessTimeout = setTimeout(function(){
showMarkers();
},10000);
},
success : function(response) {
bindMarkers(response);
processing = false;
clearTimeout(pendingProcessTimeout);
if (pendingProcess == true) {
pendingProcess = false;
showMarkers();
} else {
pendingProcessTimeout = setTimeout(function(){
showMarkers();
},10000);
}
}
});
} else {
pendingProcessTimeout = setTimeout(function(){
showMarkers();
},10000);
}
} else {
pendingProcess = true;
}
};
var markers = [];
var markersObjects = [];
var infoWindow = new google.maps.InfoWindow({ content: 'Loading...' });
function bindMarkers(mapData) {
$(mapData.result).each(function(i, e) {
if ($.inArray(e.Id,markers) == -1) {
var latLng = new google.maps.LatLng(e.Latitude, e.Longitude);
var marker = new google.maps.Marker({ position: latLng, icon : e.icon, map : map });
google.maps.event.addListener(marker, 'click', function() {
lhc.revealModal({'url':WWW_DIR_JAVASCRIPT+'chat/getonlineuserinfo/'+e.Id})
});
marker.setVisible(true);
marker.setAnimation(google.maps.Animation.DROP);
markersObjects[e.Id] = marker;
markers.push(e.Id);
clearTimeout(markersObjects[e.Id].timeOutMarker);
markersObjects[e.Id].timeOutMarker = setTimeout(function(){
markers.splice($.inArray(e.Id,markers), 1);
google.maps.event.clearInstanceListeners(markersObjects[e.Id]);
markersObjects[e.Id].setMap(null);
markersObjects[e.Id] = null;
},parseInt($('#markerTimeout option:selected').val())*1000);
} else {
markersObjects[e.Id].setIcon(e.icon);
clearTimeout(markersObjects[e.Id].timeOutMarker);
markersObjects[e.Id].timeOutMarker = setTimeout(function(){
markers.splice($.inArray(e.Id,markers), 1);
google.maps.event.clearInstanceListeners(markersObjects[e.Id]);
markersObjects[e.Id].setMap(null);
markersObjects[e.Id] = null;
},parseInt($('#markerTimeout option:selected').val())*1000);
}
});
};
$('#id_department_map_id').change(function(){
showMarkers();
lhinst.changeUserSettingsIndifferent('omap_depid',$(this).val());
});
$('#markerTimeout').change(function(){
showMarkers();
lhinst.changeUserSettingsIndifferent('omap_mtimeout',$(this).val());
});
$('#map-activator').click(function(){
setTimeout(function(){
google.maps.event.trigger(map, 'resize');
if (locationSet == false) {
locationSet = true;
map.setCenter(new google.maps.LatLng(GeoLocationData.lat, GeoLocationData.lng));
}
},500);
showMarkers();
});
};
var focused = true;
window.onfocus = window.onblur = function(e) {
focused = (e || event).type === "focus";
lhinst.focusChanged(focused);
};
window.lhcSelector = null;
$( document ).ready(function() {
lhinst.protectCSFR();
})
function chatsyncadmin()
{
lhinst.syncadmincall();
}
} catch (e) {
if (lhcError) lhcError.log(e.message, "lh.js", e.lineNumber || e.line, e.stack); else throw Error("lhc : " + e.message);
}
!function(t){function e(e){if("string"==typeof e.data&&(e.data={keys:e.data}),e.data&&e.data.keys&&"string"==typeof e.data.keys){var a=e.handler,s=e.data.keys.toLowerCase().split(" ");e.handler=function(e){if(this===e.target||!(t.hotkeys.options.filterInputAcceptingElements&&t.hotkeys.textInputTypes.test(e.target.nodeName)||t.hotkeys.options.filterContentEditable&&t(e.target).attr("contenteditable")||t.hotkeys.options.filterTextInputs&&t.inArray(e.target.type,t.hotkeys.textAcceptingInputTypes)>-1)){var n="keypress"!==e.type&&t.hotkeys.specialKeys[e.which],i=String.fromCharCode(e.which).toLowerCase(),r="",o={};t.each(["alt","ctrl","shift"],function(t,a){e[a+"Key"]&&n!==a&&(r+=a+"+")}),e.metaKey&&!e.ctrlKey&&"meta"!==n&&(r+="meta+"),e.metaKey&&"meta"!==n&&r.indexOf("alt+ctrl+shift+")>-1&&(r=r.replace("alt+ctrl+shift+","hyper+")),n?o[r+n]=!0:(o[r+i]=!0,o[r+t.hotkeys.shiftNums[i]]=!0,"shift+"===r&&(o[t.hotkeys.shiftNums[i]]=!0));for(var p=0,l=s.length;l>p;p++)if(o[s[p]])return a.apply(this,arguments)}}}}t.hotkeys={version:"0.2.0",specialKeys:{8:"backspace",9:"tab",10:"return",13:"return",16:"shift",17:"ctrl",18:"alt",19:"pause",20:"capslock",27:"esc",32:"space",33:"pageup",34:"pagedown",35:"end",36:"home",37:"left",38:"up",39:"right",40:"down",45:"insert",46:"del",59:";",61:"=",96:"0",97:"1",98:"2",99:"3",100:"4",101:"5",102:"6",103:"7",104:"8",105:"9",106:"*",107:"+",109:"-",110:".",111:"/",112:"f1",113:"f2",114:"f3",115:"f4",116:"f5",117:"f6",118:"f7",119:"f8",120:"f9",121:"f10",122:"f11",123:"f12",144:"numlock",145:"scroll",173:"-",186:";",187:"=",188:",",189:"-",190:".",191:"/",192:"`",219:"[",220:"\\",221:"]",222:"'"},shiftNums:{"`":"~",1:"!",2:"@",3:"#",4:"$",5:"%",6:"^",7:"&",8:"*",9:"(",0:")","-":"_","=":"+",";":": ","'":'"',",":"<",".":">","/":"?","\\":"|"},textAcceptingInputTypes:["text","password","number","email","url","range","date","month","week","time","datetime","datetime-local","search","color","tel"],textInputTypes:/textarea|input|select/i,options:{filterInputAcceptingElements:!0,filterTextInputs:!0,filterContentEditable:!0}},t.each(["keydown","keyup","keypress"],function(){t.event.special[this]={add:e}})}(jQuery||this.jQuery||window.jQuery);
